/*
 * Adina Vibes photo personalizer. Markup, styles and data: snippets/personalizador.liquid
 * (the data comes as JSON in [data-datos], so this file has no Liquid).
 *
 * Kept as an asset, loaded with defer only by the personalizer (product pages), on purpose:
 * Shopify bundles the {% javascript %} of every snippet into one file downloaded on every
 * page, and this script is most of it (61 KB of a 76 KB bundle, measured in Phase 8).
 * Deliberate exception to the project's {% javascript %} preference (MASTER-PLAN Phase 8B).
 * Checked by tools/revisar-referencias.js and tools/probar-personalizador.js.
 */
(function () {
  var raiz = document.querySelector('[data-personalizador]');
  if (!raiz) return;

  var datos = JSON.parse(raiz.querySelector('[data-datos]').textContent);
  var t = datos.textos;
  var lienzo = raiz.querySelector('[data-lienzo]'); // visible preview
  var ctx = lienzo.getContext('2d');
  // Full product drawn here; the visible canvas shows all of it, or only the
  // active slot while adjusting a multi-slot product. Exports use this one.
  var composicion = document.createElement('canvas');
  var cctx = composicion.getContext('2d');

  // The composition is drawn at exactly the size it is shown (screen pixels,
  // density up to DENSIDAD_MAXIMA), so the preview maps 1:1 onto the visible
  // canvas with no resampling: thin rings, the strap and the rivet stay crisp.
  // _vista_previa is re-composed at ANCHO_VISTA_PREVIA (as before), and the
  // print files never use the composition.
  var ANCHO_VISTA_PREVIA = 600;
  var ANCHO_COMPOSICION_MINIMO = 300; // on the longest side
  var AREA_MAXIMA_COMPOSICION = 6000000; // px: performance and iOS canvas memory
  var DENSIDAD_MAXIMA = 3;
  var LADO_MAXIMO_LIENZO = 2400; // visible canvas, longest side in device px
  var AJUSTE_ARRIBA = 0.375; // vertical slack: start the crop at 37.5% instead of 50%
  var MM_MINIMO_FRASE = 2.5; // printed font size below which we warn (≈7 pt)
  var PESOS = { Fraunces: 600, 'DM Sans': 500, Caveat: 400 };
  var ZOOM_MAXIMO = 4; // owner decision: 1× (automatic crop) to 4×

  // Files per line (MASTER-PLAN §6.6)
  var UNA_FOTO = { original: 4000, calidadOriginal: 0.92, recorte: 3000 };
  var VARIAS_FOTOS = { original: 1600, calidadOriginal: 0.85, factorRecorte: 2 };
  var CALIDAD_RECORTE = 0.92;
  var CALIDAD_VISTA = 0.85;
  var PRESUPUESTO_BYTES = 12 * 1048576; // above this, re-encode the reduced originals step by step
  var LIMITE_BYTES = 14 * 1048576; // Shopify rejects between 15 and 20 MB (spike)
  var PASOS_CALIDAD = [0.75, 0.65, 0.55, 0.45];
  var GIRO_FINO_MAXIMO = 15; // degrees, the fine rotation slider
  // _vista_previa of pieces that are not a full rectangle (Llavero, Pin,
  // Separador, Imán 3D): PNG with a transparent background, so the cart
  // thumbnail has no white box. Kept small: at most VISTA_PNG_MAX bytes,
  // re-encoded narrower (ANCHOS_VISTA_PNG, px) until it fits.
  var TIPOS_VISTA_PNG = ['llavero', 'pin', 'separador', '3d'];
  var VISTA_PNG_MAX = 450 * 1024;
  var ANCHOS_VISTA_PNG = [480, 400, 320];

  var estado = {
    variante: null,
    modo: 'solo_foto',
    casillas: [], // per slot: { foto, archivo, ajuste: { zoom, cx, cy } in source px, cache }
    activa: 0,
    ejemplo: null,
    frase: '',
    fuente: null,
    color: null,
    colorNombre: '',
    ajustando: false,
    galeria: 'diseno', // what the gallery shows: 'foto-N' (product photo) or 'diseno'
  };

  function plantilla(texto, valores) {
    // Fills locale placeholders (double-brace name); braces escaped so Liquid does not parse them
    return texto.replace(new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}', 'g'), function (_, clave) {
      return valores[clave] != null ? valores[clave] : '';
    });
  }

  function limitar(valor, minimo, maximo) {
    return Math.min(Math.max(valor, minimo), maximo);
  }

  // Size name for messages; single-variant products never show "Default Title"
  function nombreTamano() {
    return datos.varianteUnica ? datos.nombreProducto : estado.variante.titulo;
  }

  function variantePorId(id) {
    return datos.variantes.find(function (v) {
      return String(v.id) === String(id);
    });
  }

  // Geometry from adina.casillas: v1 has one `ventana` per mode, v2 a list of
  // `ventanas` and optionally its own px_minimo_lado per mode.
  function geometria() {
    var c = estado.variante && estado.variante.casillas;
    if (!c || !c.exterior_cm || !c.modos) return null;
    var modo = estado.modo === 'con_frase' && datos.permiteFrase && c.modos.con_frase ? 'con_frase' : 'solo_foto';
    var m = c.modos[modo] || c.modos.solo_foto;
    if (!m) return null;
    var ventanas = m.ventanas || (m.ventana ? [m.ventana] : null);
    if (!ventanas || !ventanas.length) return null;
    return {
      ancho: c.exterior_cm.ancho,
      alto: c.exterior_cm.alto,
      ventanas: ventanas,
      frase: m.frase || null,
      modo: modo,
      pxMinimo: Number(m.px_minimo_lado) || Number(estado.variante.pxMinimo) || 0,
      marco: c.marco !== false, // false: no white frame (e.g. Imán 3D)
      decoracion: c.decoracion || null, // drawn frame (e.g. MDF frame with pockets)
    };
  }

  function asegurarCasillas(g) {
    while (estado.casillas.length < g.ventanas.length) {
      estado.casillas.push({ foto: null, archivo: null, ajuste: null, cache: null });
    }
    estado.activa = limitar(estado.activa, 0, g.ventanas.length - 1);
  }

  function varias(g) {
    return g && g.ventanas.length > 1;
  }

  function proporcionVentana(g, i) {
    var v = g.ventanas[i];
    return (v.ancho * g.ancho) / (v.alto * g.alto);
  }

  // Cover crop of the source image into a window of ratio `proporcion` (w/h)
  function calcularRecorte(anchoImg, altoImg, proporcion) {
    if (anchoImg / altoImg > proporcion) {
      var w = altoImg * proporcion;
      return { x: (anchoImg - w) / 2, y: 0, w: w, h: altoImg };
    }
    var h = anchoImg / proporcion;
    return { x: 0, y: (altoImg - h) * AJUSTE_ARRIBA, w: anchoImg, h: h };
  }

  // Largest window-shaped crop that fits the photo (zoom 1×). With a
  // rotation (degrees) the window, turned by that angle over the photo, must
  // still fit inside it: its bounding box in the photo is
  // (w·|cos| + h·|sin|) × (w·|sin| + h·|cos|).
  function recorteBase(anchoImg, altoImg, proporcion, giro) {
    if (!giro) {
      if (anchoImg / altoImg > proporcion) return { w: altoImg * proporcion, h: altoImg };
      return { w: anchoImg, h: anchoImg / proporcion };
    }
    var c = Math.abs(Math.cos((giro * Math.PI) / 180));
    var sn = Math.abs(Math.sin((giro * Math.PI) / 180));
    var w = Math.min(anchoImg / (c + sn / proporcion), altoImg / (sn + c / proporcion));
    return { w: w, h: w / proporcion };
  }

  // Total rotation of a slot's photo in degrees (90° steps + fine angle)
  function giroAjuste(a) {
    return a ? (a.giro90 || 0) + (a.fino || 0) : 0;
  }

  // Crop actually used for slot i: the customer's adjustment, starting from the
  // automatic crop. Clamped inside the photo, so the window is always covered.
  function recorteCasilla(i, g) {
    var cas = estado.casillas[i];
    var img = cas && cas.foto;
    if (!img) return null;
    var p = proporcionVentana(g, i);
    var iw = img.naturalWidth;
    var ih = img.naturalHeight;
    if (!cas.ajuste) {
      var auto = calcularRecorte(iw, ih, p);
      cas.ajuste = { zoom: 1, cx: auto.x + auto.w / 2, cy: auto.y + auto.h / 2 };
    }
    var a = cas.ajuste;
    a.zoom = limitar(a.zoom, 1, ZOOM_MAXIMO);
    var giro = giroAjuste(a);
    var base = recorteBase(iw, ih, p, giro);
    var w = base.w / a.zoom;
    var h = base.h / a.zoom;
    // half the turned window's bounding box in the photo: keeps it inside
    var c = Math.abs(Math.cos((giro * Math.PI) / 180));
    var sn = Math.abs(Math.sin((giro * Math.PI) / 180));
    var ex = (w * c + h * sn) / 2;
    var ey = (w * sn + h * c) / 2;
    a.cx = limitar(a.cx, ex, iw - ex);
    a.cy = limitar(a.cy, ey, ih - ey);
    // x, y, w, h: the window in the photo's turned frame, centred on (cx, cy)
    return { x: a.cx - w / 2, y: a.cy - h / 2, w: w, h: h, cx: a.cx, cy: a.cy, giro: giro };
  }

  // Draws crop r of img into a dw × dh canvas, turned by r.giro degrees
  // (clockwise) around the crop's centre. Without a rotation it is the
  // plain sub-image copy.
  function dibujarGirado(destino, img, r, dw, dh) {
    destino.save();
    destino.imageSmoothingEnabled = true;
    destino.imageSmoothingQuality = 'high';
    destino.translate(dw / 2, dh / 2);
    destino.scale(dw / r.w, dh / r.h);
    destino.rotate((r.giro * Math.PI) / 180);
    destino.drawImage(img, -r.cx, -r.cy);
    destino.restore();
  }

  // Preview of a turned crop: a reduced copy of the whole photo is made once
  // (halving steps, good quality) and kept per slot, so dragging the fine
  // rotation slider stays fast; the copy is then drawn turned.
  function reducidaGirada(cas, img, k) {
    var ancho = Math.max(1, Math.round(img.naturalWidth * Math.min(1, k * 2)));
    if (cas.reducida && cas.reducida.img === img && cas.reducida.ancho === ancho) return cas.reducida;
    var alto = Math.max(1, Math.round((img.naturalHeight * ancho) / img.naturalWidth));
    var c = document.createElement('canvas');
    c.width = ancho;
    c.height = alto;
    dibujarReducido(c.getContext('2d'), img, 0, 0, img.naturalWidth, img.naturalHeight, ancho, alto);
    cas.reducida = { img: img, ancho: ancho, lienzo: c, factor: ancho / img.naturalWidth };
    return cas.reducida;
  }

  function rectPx(r, cw, ch) {
    return { x: r.x * cw, y: r.y * ch, w: r.ancho * cw, h: r.alto * ch };
  }

  // Sizes the composition to a width in px (keeping the product's
  // proportion, within the limits above). Returns true when it changed, so
  // the photo caches (drawn at window size) must be redrawn.
  function prepararComposicion(g, ancho) {
    var w = Math.round(ancho || ANCHO_VISTA_PREVIA);
    // the minimum applies to the longest side, so tall pieces (the strip)
    // are not forced wider than they are shown
    var minimo = ANCHO_COMPOSICION_MINIMO * Math.min(1, g.ancho / g.alto);
    if (w < minimo) w = Math.round(minimo);
    if ((w * w * g.alto) / g.ancho > AREA_MAXIMA_COMPOSICION) {
      w = Math.floor(Math.sqrt((AREA_MAXIMA_COMPOSICION * g.ancho) / g.alto));
    }
    var alto = Math.max(1, Math.round((w * g.alto) / g.ancho));
    if (composicion.width === w && composicion.height === alto) return false;
    composicion.width = w;
    composicion.height = alto;
    return true;
  }

  // Draws part of an image downscaled with good quality: high smoothing, and
  // halving steps for big reductions (a single big step aliases on some
  // browsers). Used for the photo previews only, never for the print files.
  function dibujarReducido(destino, img, sx, sy, sw, sh, dw, dh) {
    var fuente = img;
    while (sw > dw * 2.2 && sh > dh * 2.2) {
      var paso = document.createElement('canvas');
      paso.width = Math.max(1, Math.round(sw / 2));
      paso.height = Math.max(1, Math.round(sh / 2));
      var pc = paso.getContext('2d');
      pc.imageSmoothingEnabled = true;
      pc.imageSmoothingQuality = 'high';
      pc.drawImage(fuente, sx, sy, sw, sh, 0, 0, paso.width, paso.height);
      fuente = paso;
      sx = 0;
      sy = 0;
      sw = paso.width;
      sh = paso.height;
    }
    destino.imageSmoothingEnabled = true;
    destino.imageSmoothingQuality = 'high';
    destino.drawImage(fuente, sx, sy, sw, sh, 0, 0, dw, dh);
  }

  // Pre-render each slot's photo at window size, so typing the phrase stays fast
  function actualizarCache(i, g) {
    var cas = estado.casillas[i];
    var img = cas.foto || estado.ejemplo;
    if (!img) {
      cas.cache = null;
      return;
    }
    var v = rectPx(g.ventanas[i], composicion.width, composicion.height);
    var c = cas.cache || document.createElement('canvas');
    c.width = Math.max(1, Math.round(v.w));
    c.height = Math.max(1, Math.round(v.h));
    var r = cas.foto ? recorteCasilla(i, g) : calcularRecorte(img.naturalWidth, img.naturalHeight, proporcionVentana(g, i));
    if (r.giro) {
      // turned: draw from a reduced copy of the photo (2× the window's scale)
      var red = reducidaGirada(cas, img, c.width / r.w);
      var f = red.factor;
      var cx = c.getContext('2d');
      cx.clearRect(0, 0, c.width, c.height);
      dibujarGirado(cx, red.lienzo, { w: r.w * f, h: r.h * f, cx: r.cx * f, cy: r.cy * f, giro: r.giro }, c.width, c.height);
    } else {
      dibujarReducido(c.getContext('2d'), img, r.x, r.y, r.w, r.h, c.width, c.height);
    }
    cas.cache = c;
  }

  function actualizarCaches(soloActiva) {
    var g = geometria();
    if (!g) return;
    asegurarCasillas(g);
    // keep the current (screen) width; only the proportion may change
    prepararComposicion(g, composicion.width);
    g.ventanas.forEach(function (_, i) {
      if (!soloActiva || i === estado.activa) actualizarCache(i, g);
    });
  }

  // Corner radius of a window in composition px: radio_esquinas_cm (real cm,
  // scaled with the outer width) or, for "redondeado" without it, 8% of the side
  function radioVentana(ventana, v, g) {
    if (ventana && Number(ventana.radio_esquinas_cm) > 0) {
      return Math.min((Number(ventana.radio_esquinas_cm) / g.ancho) * composicion.width, Math.min(v.w, v.h) / 2);
    }
    return datos.forma === 'redondeado' ? Math.min(v.w, v.h) * 0.08 : 0;
  }

  function trazarRedondeado(c, x, y, w, h, r) {
    if (!r) {
      c.rect(x, y, w, h);
      return;
    }
    c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r);
    c.closePath();
  }

  function trazarMascara(c, v, radio) {
    c.beginPath();
    if (datos.forma === 'circulo') {
      c.arc(v.x + v.w / 2, v.y + v.h / 2, Math.min(v.w, v.h) / 2, 0, Math.PI * 2);
    } else {
      trazarRedondeado(c, v.x, v.y, v.w, v.h, radio || 0); // rectangulo: straight corners
    }
  }

  function conRelieve() {
    return datos.tipo === '3d' || datos.tipo === '3d_marco';
  }

  // Resin dome over a slot (preview and _vista_previa only, never in the
  // print files). Tuned to the real magnet: a thin crisp rim, bright at the
  // bottom and right and almost invisible at the top and left, an almost
  // imperceptible inner shadow, one small soft reflection, clean centre.
  // Retune here (alphas 0–1; sizes as a fraction of the slot width).
  var DOMO = {
    bordeAncho: 0.02, // rim width
    bordeFuerte: 0.5, // rim alpha at the bottom-right
    bordeSuave: 0.05, // rim alpha at the top-left
    sombra: 0.05, // inner shadow alpha at the very edge
    reflejo: 0.2, // reflection alpha at its centre
    reflejoTamano: 0.14, // reflection radius
  };

  function dibujarDomo(c, v, radio) {
    var bisel = v.w * DOMO.bordeAncho;
    c.save();
    trazarMascara(c, v, radio);
    c.clip();

    // Inner shadow: only the outermost edge, centre untouched
    var sombra = c.createRadialGradient(
      v.x + v.w / 2, v.y + v.h / 2, Math.min(v.w, v.h) * 0.46,
      v.x + v.w / 2, v.y + v.h / 2, Math.max(v.w, v.h) * 0.71
    );
    sombra.addColorStop(0, 'rgba(0, 0, 0, 0)');
    sombra.addColorStop(1, 'rgba(0, 0, 0, ' + DOMO.sombra + ')');
    c.fillStyle = sombra;
    c.fillRect(v.x, v.y, v.w, v.h);

    // Crisp rim: faint at the top-left, bright at the bottom-right
    var borde = c.createLinearGradient(v.x, v.y, v.x + v.w, v.y + v.h);
    borde.addColorStop(0, 'rgba(255, 255, 255, ' + DOMO.bordeSuave + ')');
    borde.addColorStop(0.55, 'rgba(255, 255, 255, ' + DOMO.bordeSuave + ')');
    borde.addColorStop(1, 'rgba(255, 255, 255, ' + DOMO.bordeFuerte + ')');
    c.lineWidth = bisel;
    c.strokeStyle = borde;
    c.beginPath();
    trazarRedondeado(c, v.x + bisel / 2, v.y + bisel / 2, v.w - bisel, v.h - bisel, Math.max(0, radio - bisel / 2));
    c.stroke();

    // One small soft reflection, upper left
    var radioReflejo = v.w * DOMO.reflejoTamano;
    c.translate(v.x + v.w * 0.22, v.y + v.h * 0.16);
    c.rotate(-0.35);
    c.scale(1, 0.5);
    var brillo = c.createRadialGradient(0, 0, 0, 0, 0, radioReflejo);
    brillo.addColorStop(0, 'rgba(255, 255, 255, ' + DOMO.reflejo + ')');
    brillo.addColorStop(1, 'rgba(255, 255, 255, 0)');
    c.fillStyle = brillo;
    c.beginPath();
    c.arc(0, 0, radioReflejo, 0, Math.PI * 2);
    c.fill();
    c.restore();
  }

  function hayFotos() {
    return estado.casillas.some(function (c) {
      return c.foto;
    });
  }

  // Flat drawn frame: background, and per pocket a darker floor and a thin outline
  // Real cm to composition px (the outer width maps to the canvas width)
  function cmAPx(cm, g, cw) {
    return (Number(cm) / g.ancho) * cw;
  }

  // Metal with a soft vertical gradient (lighter on top): silver or gold
  function metal(c, e, y0, y1) {
    var oro = e.metal === 'oro';
    var gr = c.createLinearGradient(0, y0, 0, y1);
    gr.addColorStop(0, oro ? '#F6DE8D' : '#E9ECEF');
    gr.addColorStop(0.5, e.color || (oro ? '#C59538' : '#C0C4C8'));
    gr.addColorStop(1, oro ? '#8A6420' : '#8E9399');
    return gr;
  }

  function dibujarAro(e, g, cw, ch) {
    var cx = e.cx * cw;
    var cy = e.cy * ch;
    var r = cmAPx(e.radio_cm, g, cw);
    var grosor = Math.max(1.5, cmAPx(e.grosor_cm || 0.15, g, cw));
    // Only an arc segment (degrees, clockwise from the right), redrawn over
    // another ring so the two look interlocked. It repeats exactly what the
    // full ring draws at those angles (same centre, radius, thickness,
    // gradient, flat ends and the matching piece of the split-ring hint), so
    // the overdraw only shows where it crosses the other ring.
    var desde = 0;
    var hasta = Math.PI * 2;
    if (e.desde != null && e.hasta != null) {
      desde = (e.desde * Math.PI) / 180;
      hasta = (e.hasta * Math.PI) / 180;
    }
    cctx.save();
    cctx.lineCap = 'butt';
    cctx.lineWidth = grosor;
    cctx.strokeStyle = metal(cctx, e, cy - r, cy + r);
    cctx.beginPath();
    cctx.arc(cx, cy, r, desde, hasta);
    cctx.stroke();
    // split-ring overlap hint (inner arc between 27° and 99°), clipped to the segment
    var pistaDesde = Math.max(desde, Math.PI * 0.15);
    var pistaHasta = Math.min(hasta, Math.PI * 0.55);
    if (pistaHasta > pistaDesde) {
      cctx.lineWidth = grosor * 0.6;
      cctx.beginPath();
      cctx.arc(cx, cy, r - grosor * 0.9, pistaDesde, pistaHasta);
      cctx.stroke();
    }
    cctx.restore();
  }

  function colorAccesorio(e) {
    if (e.color && e.color !== 'acc') return e.color;
    if (estado.colorAccesorio) return estado.colorAccesorio.hex;
    var lista = coloresVariante();
    return lista.length ? lista[0].hex : '#A6A6AA';
  }

  function mezclar(hex, otro, cuanto) {
    var a = parseInt(hex.slice(1), 16);
    var b = parseInt(otro.slice(1), 16);
    var c = [16, 8, 0].map(function (d) {
      var x = (a >> d) & 255;
      var y = (b >> d) & 255;
      return Math.round(x + (y - x) * cuanto);
    });
    return 'rgb(' + c.join(',') + ')';
  }

  function conAlfa(rgb, alfa) {
    return rgb.replace('rgb(', 'rgba(').replace(')', ', ' + alfa + ')');
  }

  // 0 (black) to 1 (white)
  function luminancia(hex) {
    var a = parseInt(hex.slice(1), 16);
    return (0.299 * ((a >> 16) & 255) + 0.587 * ((a >> 8) & 255) + 0.114 * (a & 255)) / 255;
  }

  // Seeded pseudo-random numbers (mulberry32): the same sequence on every
  // render and every device
  function azar(semilla) {
    var s = semilla >>> 0;
    return function () {
      s = (s + 0x6d2b79f5) >>> 0;
      var t = s;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function mezclarAngulos(a, b, k) {
    return Math.atan2(Math.sin(a) * (1 - k) + Math.sin(b) * k, Math.cos(a) * (1 - k) + Math.cos(b) * k);
  }

  // A lock of fine hairs side by side (one path, one stroke), each a little
  // different in length and bend, fanning out slightly
  function mechonPompon(c, x, y, a, largo, ancho, pelos, curva, rnd) {
    var dx = Math.cos(a);
    var dy = Math.sin(a);
    var nx = -dy;
    var ny = dx;
    c.beginPath();
    for (var i = 0; i < pelos; i++) {
      var o = (rnd() - 0.5) * ancho;
      var atras = rnd() * largo * 0.25;
      var l = largo * (0.65 + rnd() * 0.35);
      var k = curva + (rnd() - 0.5) * 0.2 + (o / ancho) * 0.25;
      var sx = x + nx * o - dx * atras;
      var sy = y + ny * o - dy * atras;
      c.moveTo(sx, sy);
      c.quadraticCurveTo(sx + dx * l * 0.5 + nx * k * l * 0.3, sy + dy * l * 0.5 + ny * k * l * 0.3, sx + dx * l + nx * k * l, sy + dy * l + ny * k * l);
    }
    c.stroke();
  }

  // Fur pompón (Llavero Pompón), procedural and deterministic, drawn centred
  // in a square canvas of side "lado": R = outer radius with the fur, "pelo"
  // = how far the fur sticks out past the round body, "corona" = where the
  // hair grows from (degrees from the top, clockwise; where the chain is
  // tied). Layers: a very soft shadow, the body (darker core, lighter rim,
  // fading out at its edge), big soft light and dark clumps, then 320 locks
  // of fine hairs (body, rim past the outline, highlights on the lit side).
  // Colours come from the chosen colour with mezclar; darker colours get
  // stronger highlights, so Negro never reads as a flat black disc.
  var POMPON = { mechasCuerpo: 170, mechasBorde: 120, brillos: 30, grumos: 24, pelos: 11 };
  function pintarPompon(c, lado, R, pelo, hex, coronaGrados) {
    var cx = lado / 2;
    var cy = lado / 2;
    var Rb = R - pelo;
    var realce = 1 - luminancia(hex);
    var rnd = azar(11);
    var lx = -0.55; // light from the top left
    var ly = -0.83;
    var tonos = [
      mezclar(hex, '#000000', 0.34 - 0.2 * realce),
      mezclar(hex, '#000000', 0.16 - 0.09 * realce),
      mezclar(hex, '#000000', 0),
      mezclar(hex, '#FFFFFF', 0.1 + 0.16 * realce),
      mezclar(hex, '#FFFFFF', 0.22 + 0.24 * realce),
      mezclar(hex, '#FFFFFF', 0.38 + 0.28 * realce),
    ];
    // lighter toward the rim and toward the light, with some variation
    function tono(r, a, sesgo) {
      var cara = -(Math.cos(a) * lx + Math.sin(a) * ly);
      var k = 0.28 + r * 0.36 + cara * 0.24 * r + sesgo + (rnd() - 0.5) * 0.5;
      return tonos[Math.max(0, Math.min(5, Math.round(k * 5)))];
    }
    var fase1 = rnd() * 6.3;
    var fase2 = rnd() * 6.3;
    function radio(a) {
      return Rb * (1 + 0.02 * Math.sin(3 * a + fase1) + 0.012 * Math.sin(5 * a + fase2));
    }
    // hair direction: combed downward from the crown, turning outward
    // toward the rim, with a gentle smooth swirl (no starburst)
    var corona = ((Number(coronaGrados) || 0) * Math.PI) / 180;
    var kx = cx + Math.sin(corona) * Rb * 0.45;
    var ky = cy - Math.cos(corona) * Rb * 0.45;
    var peine = Math.PI * 0.56;
    function flujo(x, y) {
      var a = Math.atan2(y - ky, x - kx);
      var r = Math.min(1, Math.hypot(x - kx, y - ky) / (Rb * 1.3));
      var dif = Math.atan2(Math.sin(a - peine), Math.cos(a - peine));
      return peine + dif * (0.3 + 0.7 * Math.pow(r, 1.3)) + 0.25 * Math.sin(2.3 * a + 5 * r + fase1);
    }

    // very soft shadow, only under the lower half (it must not show as a
    // grey ring through the fur's soft edge)
    var sy = cy + R * 0.22;
    var sombra = c.createRadialGradient(cx, sy, R * 0.4, cx, sy, R * 1.02);
    sombra.addColorStop(0, 'rgba(59, 42, 34, 0.16)');
    sombra.addColorStop(1, 'rgba(59, 42, 34, 0)');
    c.fillStyle = sombra;
    c.beginPath();
    c.arc(cx, sy, R * 1.02, 0, Math.PI * 2);
    c.fill();

    // body: darker core, lighter rim, fading out at its edge (no hard circle)
    var borde = Rb + pelo * 0.45;
    var fin = Rb / borde;
    var cuerpo = c.createRadialGradient(cx - Rb * 0.12, cy - Rb * 0.16, 0, cx, cy, borde);
    cuerpo.addColorStop(0, tonos[1]);
    cuerpo.addColorStop(fin * 0.55, tonos[2]);
    cuerpo.addColorStop(fin * 0.92, tonos[3]);
    cuerpo.addColorStop(fin, conAlfa(mezclar(hex, '#FFFFFF', 0.12 + 0.18 * realce), 0.75));
    cuerpo.addColorStop(1, conAlfa(mezclar(hex, '#FFFFFF', 0.16 + 0.2 * realce), 0));
    c.fillStyle = cuerpo;
    c.beginPath();
    c.arc(cx, cy, borde, 0, Math.PI * 2);
    c.fill();
    // a soft darker area toward the bottom right
    var sx2 = cx + Rb * 0.3;
    var sy2 = cy + Rb * 0.42;
    var sombraCuerpo = c.createRadialGradient(sx2, sy2, 0, sx2, sy2, Rb * 0.85);
    sombraCuerpo.addColorStop(0, 'rgba(0, 0, 0, ' + (0.2 - 0.08 * realce) + ')');
    sombraCuerpo.addColorStop(1, 'rgba(0, 0, 0, 0)');
    c.fillStyle = sombraCuerpo;
    c.beginPath();
    c.arc(sx2, sy2, Rb * 0.85, 0, Math.PI * 2);
    c.fill();

    // big soft clumps (light and dark), elongated along the hair
    for (var i = 0; i < POMPON.grumos; i++) {
      var r0 = Math.sqrt(rnd()) * Rb * 0.8;
      var a0 = rnd() * Math.PI * 2;
      var x0 = cx + Math.cos(a0) * r0;
      var y0 = cy + Math.sin(a0) * r0;
      var claro = rnd() < 0.55;
      var largo = R * (0.24 + rnd() * 0.26);
      var color = claro ? mezclar(hex, '#FFFFFF', 0.32 + 0.3 * realce) : mezclar(hex, '#000000', 0.32 - 0.12 * realce);
      c.save();
      c.translate(x0, y0);
      c.rotate(flujo(x0, y0));
      c.scale(1, 0.3);
      var grumo = c.createRadialGradient(0, 0, 0, 0, 0, largo);
      grumo.addColorStop(0, conAlfa(color, claro ? 0.36 : 0.28));
      grumo.addColorStop(1, conAlfa(color, 0));
      c.fillStyle = grumo;
      c.beginPath();
      c.arc(0, 0, largo, 0, Math.PI * 2);
      c.fill();
      c.restore();
    }

    c.lineCap = 'round';
    var fino = Math.max(0.5, R * 0.0045);
    // locks over the body, along the flow
    for (var j = 0; j < POMPON.mechasCuerpo; j++) {
      var r1 = Math.sqrt((j + rnd()) / POMPON.mechasCuerpo) * Rb * 0.88;
      var a1 = rnd() * Math.PI * 2;
      var x1 = cx + Math.cos(a1) * r1;
      var y1 = cy + Math.sin(a1) * r1;
      c.globalAlpha = 0.3 + rnd() * 0.3;
      c.strokeStyle = tono(r1 / Rb, a1, 0);
      c.lineWidth = fino * (0.8 + rnd() * 0.6);
      mechonPompon(c, x1, y1, flujo(x1, y1) + (rnd() - 0.5) * 0.3, R * (0.2 + rnd() * 0.2), R * (0.06 + rnd() * 0.07), POMPON.pelos, (rnd() - 0.5) * 0.35, rnd);
    }
    // rim locks: start inside and end past the body by different amounts
    // (a ragged, soft outline), leaning a little downward on the sides
    for (var k = 0; k < POMPON.mechasBorde; k++) {
      var b = ((k + rnd()) / POMPON.mechasBorde) * Math.PI * 2;
      var rb = radio(b);
      var r2 = rb * (0.78 + rnd() * 0.16);
      var x2 = cx + Math.cos(b) * r2;
      var y2 = cy + Math.sin(b) * r2;
      c.globalAlpha = 0.25 + rnd() * 0.3;
      c.strokeStyle = tono(0.92, b, 0.1);
      c.lineWidth = fino * (0.7 + rnd() * 0.5);
      mechonPompon(c, x2, y2, mezclarAngulos(b, Math.PI * 0.5, 0.28) + (rnd() - 0.5) * 0.5, rb - r2 + pelo * (0.35 + rnd() * 0.65), R * (0.05 + rnd() * 0.05), POMPON.pelos, (rnd() < 0.5 ? -1 : 1) * (0.2 + rnd() * 0.3), rnd);
    }
    // soft highlights on the lit side
    for (var m = 0; m < POMPON.brillos; m++) {
      var h = Math.atan2(ly, lx) + (rnd() - 0.5) * 2.1;
      var rh = Rb * (0.3 + rnd() * 0.6);
      var x3 = cx + Math.cos(h) * rh;
      var y3 = cy + Math.sin(h) * rh;
      c.globalAlpha = 0.2 + rnd() * 0.25;
      c.strokeStyle = tonos[5];
      c.lineWidth = fino * 0.8;
      mechonPompon(c, x3, y3, flujo(x3, y3) + (rnd() - 0.5) * 0.3, R * (0.15 + rnd() * 0.15), R * 0.04, Math.ceil(POMPON.pelos * 0.7), (rnd() - 0.5) * 0.25, rnd);
    }
    c.globalAlpha = 1;
  }

  // The pompón is drawn once per colour and size into its own canvas and
  // then only copied, so redrawing the preview (typing, adjusting) stays fast.
  // At most 3 kept (the preview, _vista_previa and one more): on a big 3x
  // screen each one can be several MB.
  var cachePompon = {};
  function lienzoPompon(R, pelo, hex, corona) {
    var lado = Math.ceil(R * 2.6);
    var clave = [hex, lado, Math.round(pelo * 10), corona].join('|');
    if (!cachePompon[clave]) {
      var claves = Object.keys(cachePompon);
      if (claves.length >= 3) delete cachePompon[claves[0]];
      var c = document.createElement('canvas');
      c.width = lado;
      c.height = lado;
      pintarPompon(c.getContext('2d'), lado, R, pelo, hex, corona);
      cachePompon[clave] = c;
    }
    return cachePompon[clave];
  }

  // Element pompon_pelo: cx, cy (centre), diametro_cm (outer, with the fur),
  // pelo_cm, corona (degrees), color ("acc" = the chosen colour)
  function dibujarPompon(e, g, cw, ch) {
    var R = cmAPx(e.diametro_cm || 5.8, g, cw) / 2;
    var pelo = Math.min(R * 0.4, cmAPx(e.pelo_cm || 0.35, g, cw));
    var c = lienzoPompon(R, pelo, colorAccesorio(e), Number(e.corona) || 0);
    cctx.drawImage(c, e.cx * cw - c.width / 2, e.cy * ch - c.height / 2);
  }

  // Element cadena_ovalada: a short chain of small oval links from (x1, y1)
  // to (x2, y2), alternating face-on (an oval) and edge-on (a narrow bar),
  // each link overlapping the next. largo_cm × ancho_cm per link, wire grosor_cm.
  function dibujarCadena(e, g, cw, ch) {
    var x1 = e.x1 * cw;
    var y1 = e.y1 * ch;
    var x2 = e.x2 * cw;
    var y2 = e.y2 * ch;
    var largo = cmAPx(e.largo_cm || 0.5, g, cw);
    var ancho = cmAPx(e.ancho_cm || 0.28, g, cw);
    var grosor = Math.max(1, cmAPx(e.grosor_cm || 0.07, g, cw));
    var total = Math.hypot(x2 - x1, y2 - y1);
    var angulo = Math.atan2(y2 - y1, x2 - x1);
    var paso = largo * 0.8;
    var n = Math.max(2, Math.round((total - largo) / paso) + 1);
    paso = (total - largo) / (n - 1);
    cctx.save();
    cctx.lineCap = 'round';
    for (var i = 0; i < n; i++) {
      var d = largo / 2 + paso * i;
      var mx = x1 + Math.cos(angulo) * d;
      var my = y1 + Math.sin(angulo) * d;
      var deFrente = i % 2 === 0;
      var ry = deFrente ? Math.max(grosor, ancho / 2 - grosor / 2) : grosor * 0.55;
      cctx.lineWidth = deFrente ? grosor : grosor * 1.1;
      cctx.strokeStyle = metal(cctx, e, my - largo / 2, my + largo / 2);
      cctx.beginPath();
      cctx.ellipse(mx, my, largo / 2 - grosor / 2, ry, angulo, 0, Math.PI * 2);
      cctx.stroke();
      if (deFrente) {
        // a thin bright line on the upper side of the wire
        cctx.lineWidth = Math.max(0.6, grosor * 0.35);
        cctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
        cctx.beginPath();
        cctx.ellipse(mx, my, largo / 2 - grosor / 2, ry, angulo, Math.PI * 1.1, Math.PI * 1.75);
        cctx.stroke();
      }
    }
    cctx.restore();
  }

  // Strap (version 1 style: flat band, edge line, domed rivet) with the
  // real shape, measured on the reference photo of 12 straps: a narrower
  // neck at the top with a flat edge and small rounded corners, short
  // straight angled shoulders rounded where they meet the sides. The ring
  // passes behind the neck (draw the ring first, then the strap), so the
  // leather covers its lower wire and the ring shows on both sides. No back
  // layer is visible on the real strap. Optional tilt "angulo" (degrees,
  // pivot at the top centre).
  function trazarCorrea(c, x, y, w, l, lengua) {
    var lw = Math.min(lengua.w, w);
    var cx = x + w / 2;
    var nl = cx - lw / 2;
    var nr = cx + lw / 2;
    var yh = y + lengua.h; // shoulders start (bottom of the neck)
    var yb = yh + lengua.hombro; // the sides start here
    var rn = Math.min(lengua.radio, lw / 2);
    var rh = Math.min(lengua.radioHombro, (x + w - nr) * 0.9, l * 0.2);
    var rb = w * 0.18;
    c.moveTo(nl, y + rn);
    c.arcTo(nl, y, cx, y, rn);
    c.arcTo(nr, y, nr, y + rn, rn);
    c.lineTo(nr, yh);
    c.arcTo(x + w, yb, x + w, yb + rh, rh);
    c.arcTo(x + w, y + l, x + w - rb, y + l, rb);
    c.arcTo(x, y + l, x, y + l - rb, rb);
    c.lineTo(x, yb + rh);
    c.arcTo(x, yb, nl, yh, rh);
    c.lineTo(nl, yh);
    c.closePath();
  }

  function dibujarCorrea(e, g, cw, ch) {
    var w = cmAPx(e.ancho_cm || 1.7, g, cw);
    var l = cmAPx(e.largo_cm || 7.6, g, cw);
    var x = e.cx * cw - w / 2;
    var y = e.y * ch;
    var lg = e.lengua || {};
    var lengua = {
      w: cmAPx(lg.ancho_cm || 0.9, g, cw),
      h: cmAPx(lg.alto_cm || 0.6, g, cw),
      hombro: cmAPx(lg.hombro_cm || 0.1, g, cw),
      radio: cmAPx(lg.radio_cm || 0.07, g, cw),
      radioHombro: cmAPx(lg.radio_hombro_cm || 0.15, g, cw),
    };
    var base = colorAccesorio(e);
    var giro = ((Number(e.angulo) || 0) * Math.PI) / 180;
    cctx.save();
    cctx.translate(x + w / 2, y);
    cctx.rotate(giro);
    cctx.translate(-(x + w / 2), -y);

    cctx.save();
    cctx.beginPath();
    trazarCorrea(cctx, x, y, w, l, lengua);
    cctx.fillStyle = base;
    cctx.fill();
    cctx.clip();
    // where the strap bends over the ring: a little darker at the top
    var pliegue = cctx.createLinearGradient(0, y, 0, y + lengua.h + lengua.hombro);
    pliegue.addColorStop(0, mezclar(base, '#000000', 0.28));
    pliegue.addColorStop(1, mezclar(base, '#000000', 0));
    cctx.fillStyle = pliegue;
    cctx.fillRect(x, y, w, lengua.h + lengua.hombro);
    // gentle side shading
    var lado = cctx.createLinearGradient(x, 0, x + w, 0);
    lado.addColorStop(0, 'rgba(0, 0, 0, 0.10)');
    lado.addColorStop(0.5, 'rgba(255, 255, 255, 0.05)');
    lado.addColorStop(1, 'rgba(0, 0, 0, 0.14)');
    cctx.fillStyle = lado;
    cctx.fillRect(x, y, w, l);
    cctx.restore();
    // edge line
    cctx.beginPath();
    trazarCorrea(cctx, x, y, w, l, lengua);
    cctx.lineWidth = Math.max(1, cw * 0.002);
    cctx.strokeStyle = mezclar(base, '#000000', 0.35);
    cctx.stroke();
    // domed rivet, below the shoulders
    var rv = e.remache || {};
    var rr = cmAPx(rv.diametro_cm || 0.72, g, cw) / 2;
    var rx = x + w / 2;
    var ry = y + cmAPx(rv.y_cm || 1.76, g, cw);
    var domo = cctx.createRadialGradient(rx - rr * 0.35, ry - rr * 0.35, rr * 0.1, rx, ry, rr);
    var oro = rv.metal !== 'plata';
    domo.addColorStop(0, oro ? '#FBEAB0' : '#F4F6F8');
    domo.addColorStop(0.55, rv.color || (oro ? '#C59538' : '#C0C4C8'));
    domo.addColorStop(1, oro ? '#7E5A1C' : '#80858B');
    cctx.fillStyle = domo;
    cctx.beginPath();
    cctx.arc(rx, ry, rr, 0, Math.PI * 2);
    cctx.fill();
    cctx.restore();
  }

  // Small rounded-rectangle metal loop joining the split ring to the holder
  function dibujarEslabon(e, g, cw, ch) {
    var w = cmAPx(e.ancho_cm || 0.45, g, cw);
    var h = cmAPx(e.alto_cm || 0.9, g, cw);
    var grosor = Math.max(1.2, cmAPx(e.grosor_cm || 0.06, g, cw));
    var x = e.cx * cw - w / 2;
    var y = e.y * ch;
    cctx.save();
    cctx.lineWidth = grosor;
    cctx.strokeStyle = metal(cctx, e, y, y + h);
    cctx.beginPath();
    trazarRedondeado(cctx, x, y, w, h, w / 2);
    cctx.stroke();
    cctx.restore();
  }

  // Pin face (element pelicula): a glossy film over the photo, flat (no
  // dome or relief, those are only for the 3D types) and no frame: a soft
  // diagonal translucent band, a very subtle darkening toward the edges and
  // a hair-thin edge so it does not read as a flat sticker. Composition only
  // (preview and _vista_previa); the print crop is cut from the photo itself.
  function dibujarPelicula(e, g, cw, ch) {
    g.ventanas.forEach(function (ventana) {
      var v = rectPx(ventana, cw, ch);
      var radio = radioVentana(ventana, v, g);
      cctx.save();
      trazarMascara(cctx, v, radio);
      cctx.clip();
      var cx = v.x + v.w / 2;
      var cy = v.y + v.h / 2;
      var lejos = Math.sqrt(v.w * v.w + v.h * v.h) / 2;
      var vineta = cctx.createRadialGradient(cx, cy, lejos * 0.5, cx, cy, lejos);
      vineta.addColorStop(0, 'rgba(0, 0, 0, 0)');
      vineta.addColorStop(1, 'rgba(0, 0, 0, 0.14)');
      cctx.fillStyle = vineta;
      cctx.fillRect(v.x, v.y, v.w, v.h);
      var brillo = cctx.createLinearGradient(v.x, v.y, v.x + v.w, v.y + v.h);
      brillo.addColorStop(0, 'rgba(255, 255, 255, 0.12)');
      brillo.addColorStop(0.2, 'rgba(255, 255, 255, 0)');
      brillo.addColorStop(0.3, 'rgba(255, 255, 255, 0)');
      brillo.addColorStop(0.38, 'rgba(255, 255, 255, 0.24)');
      brillo.addColorStop(0.48, 'rgba(255, 255, 255, 0)');
      brillo.addColorStop(1, 'rgba(255, 255, 255, 0)');
      cctx.fillStyle = brillo;
      cctx.fillRect(v.x, v.y, v.w, v.h);
      // hair-thin edge: light just inside, faint dark at the very edge
      var fino = Math.max(1, v.w * 0.004);
      cctx.lineWidth = fino;
      cctx.strokeStyle = 'rgba(255, 255, 255, 0.4)';
      cctx.beginPath();
      trazarRedondeado(cctx, v.x + fino * 1.5, v.y + fino * 1.5, v.w - fino * 3, v.h - fino * 3, Math.max(0, radio - fino * 1.5));
      cctx.stroke();
      cctx.strokeStyle = 'rgba(40, 30, 25, 0.18)';
      cctx.beginPath();
      trazarRedondeado(cctx, v.x + fino / 2, v.y + fino / 2, v.w - fino, v.h - fino, Math.max(0, radio - fino / 2));
      cctx.stroke();
      cctx.restore();
    });
  }

  // Bookmark fold (element doblez, Separador de libro): the magnetic clip
  // folds over the top edge of the visible face. A soft shadow fading down
  // from the top edge (sombra_cm) and a thin fold line: a faint dark line at
  // the very edge with a faint highlight just below. Flat, no gloss.
  // Composition only (preview and _vista_previa), never in the print files.
  function dibujarDoblez(e, g, cw, ch) {
    var alto = Math.max(2, cmAPx(e.sombra_cm || 0.25, g, cw));
    g.ventanas.forEach(function (ventana) {
      var v = rectPx(ventana, cw, ch);
      cctx.save();
      trazarMascara(cctx, v, radioVentana(ventana, v, g));
      cctx.clip();
      var sombra = cctx.createLinearGradient(0, v.y, 0, v.y + alto);
      sombra.addColorStop(0, 'rgba(40, 30, 25, 0.28)');
      sombra.addColorStop(0.35, 'rgba(40, 30, 25, 0.1)');
      sombra.addColorStop(1, 'rgba(40, 30, 25, 0)');
      cctx.fillStyle = sombra;
      cctx.fillRect(v.x, v.y, v.w, alto);
      var fino = Math.max(1, v.w * 0.006);
      cctx.fillStyle = 'rgba(30, 20, 15, 0.35)';
      cctx.fillRect(v.x, v.y, v.w, fino);
      cctx.fillStyle = 'rgba(255, 255, 255, 0.45)';
      cctx.fillRect(v.x, v.y + fino, v.w, fino);
      cctx.restore();
    });
  }

  // Open bookmark clip (element clip_abierto, Separador), seen in light
  // perspective. The photo face is the front half; the plain back half hangs
  // from the same fold at the top, opened `apertura` degrees away from the
  // viewer (behind the face). The whole clip is turned `giro_horizontal`
  // degrees about its vertical axis (yaw, like a door) and seen from
  // `perspectiva` face widths away: the face is foreshortened and its nearer
  // edge slightly taller; the opening shows as a V beyond the edge turned to
  // the viewer. The photo is drawn in thin vertical strips scaled to their
  // height (preview and _vista_previa only; the print files are cut from the
  // photo itself). Hidden while adjusting: the face is then frontal.
  // Geometry in units of the face width.
  function medidasClip(e) {
    var giro = Math.max(-45, Math.min(45, e.giro_horizontal == null ? 25 : Number(e.giro_horizontal)));
    var apertura = Math.max(0, Math.min(30, e.apertura == null ? 12 : Number(e.apertura)));
    var distancia = Math.max(2.5, Math.min(20, e.perspectiva == null ? 5 : Number(e.perspectiva)));
    return { giro: (giro * Math.PI) / 180, apertura: (apertura * Math.PI) / 180, distancia: distancia };
  }

  function geometriaClip(e, alto) {
    var m = medidasClip(e);
    var cos = Math.cos(m.giro);
    var sin = Math.sin(m.giro);
    // 3D point (x across the face from 0 to 1, y down from the fold, z away
    // from the viewer) to the screen, centred on the face
    var proyectar = function (x, y, z) {
      var cx = x - 0.5;
      var xr = cx * cos + z * sin;
      var zr = -cx * sin + z * cos;
      var k = m.distancia / (m.distancia + zr);
      return [xr * k, (y - alto / 2) * k];
    };
    var ca = Math.cos(m.apertura);
    var sa = Math.sin(m.apertura);
    var cara = [proyectar(0, 0, 0), proyectar(1, 0, 0), proyectar(1, alto, 0), proyectar(0, alto, 0)];
    var tras = [proyectar(0, 0, 0), proyectar(1, 0, 0), proyectar(1, alto * ca, alto * sa), proyectar(0, alto * ca, alto * sa)];
    var todos = cara.concat(tras);
    var xs = todos.map(function (p) { return p[0]; });
    var ys = todos.map(function (p) { return p[1]; });
    var minX = Math.min.apply(null, xs);
    var minY = Math.min.apply(null, ys);
    return {
      cara: cara,
      tras: tras,
      proyectar: proyectar,
      minX: minX,
      minY: minY,
      ancho: Math.max.apply(null, xs) - minX,
      alto: Math.max.apply(null, ys) - minY,
      altoCara: alto,
    };
  }

  // Draws the open clip with the group's top-left at (x0, y0), s px per unit
  // of face width; the composition must be s px wide. Returns the group's box.
  function dibujarClip(c, e, g, x0, y0, s, sombra) {
    var gc = geometriaClip(e, g.alto / g.ancho);
    var aPx = function (p) { return [x0 + (p[0] - gc.minX) * s, y0 + (p[1] - gc.minY) * s]; };
    var trazar = function (puntos) {
      c.beginPath();
      c.moveTo(puntos[0][0], puntos[0][1]);
      for (var i = 1; i < puntos.length; i++) c.lineTo(puntos[i][0], puntos[i][1]);
      c.closePath();
    };
    // back half: plain material, with a soft shadow under it
    var t = gc.tras.map(aPx);
    c.save();
    if (sombra) aplicarSombra(c, sombra);
    var material = c.createLinearGradient(t[0][0], t[0][1], t[3][0], t[3][1]);
    material.addColorStop(0, '#F4F0EA');
    material.addColorStop(1, '#DED6CB');
    c.fillStyle = material;
    trazar(t);
    c.fill();
    c.restore();
    c.save();
    c.lineWidth = Math.max(1, s * 0.006);
    c.strokeStyle = 'rgba(60, 50, 45, 0.3)';
    trazar(t);
    c.stroke();
    c.restore();
    // the face's outline casts a soft shadow onto the back half and the page
    var f = gc.cara.map(aPx);
    c.save();
    if (sombra) aplicarSombra(c, sombra * 0.7);
    c.fillStyle = '#E8E2D9';
    trazar(f);
    c.fill();
    c.restore();
    // the photo, foreshortened: thin vertical strips on whole device-pixel
    // columns (integer x and width, overlapping the next by 1 px, so there are
    // no anti-aliased seams), each scaled to its height; the source column of
    // each strip comes from inverting the projection. Clipped to the exact
    // outline, so the top and bottom edges stay clean straight lines.
    var fuenteW = composicion.width;
    var fuenteH = composicion.height;
    var muestras = 64;
    var xsPantalla = [];
    for (var k = 0; k <= muestras; k++) xsPantalla.push(aPx(gc.proyectar(k / muestras, 0, 0))[0]);
    var uDeX = function (x) {
      // screen x to face position u (0..1): monotonic, linear between samples
      if (x <= xsPantalla[0]) return 0;
      for (var j = 1; j <= muestras; j++) {
        if (x <= xsPantalla[j]) return (j - 1 + (x - xsPantalla[j - 1]) / (xsPantalla[j] - xsPantalla[j - 1])) / muestras;
      }
      return 1;
    };
    var paso = 2;
    var desde = Math.floor(xsPantalla[0]);
    var hasta = Math.ceil(xsPantalla[muestras]);
    c.save();
    trazar(f);
    c.clip();
    c.imageSmoothingEnabled = true;
    c.imageSmoothingQuality = 'high';
    for (var X = desde; X < hasta; X += paso) {
      var u0 = uDeX(X);
      var u1 = uDeX(X + paso);
      if (u1 <= u0) continue;
      var um = (u0 + u1) / 2;
      var arriba = aPx(gc.proyectar(um, 0, 0))[1];
      var abajo = aPx(gc.proyectar(um, gc.altoCara, 0))[1];
      c.drawImage(composicion, u0 * fuenteW, 0, (u1 - u0) * fuenteW, fuenteH, X, arriba, paso + 1, abajo - arriba);
    }
    c.restore();
    // the fold joining both halves along the shared top edge
    c.save();
    c.lineCap = 'round';
    c.lineWidth = Math.max(1.5, s * 0.03);
    c.strokeStyle = '#EDE7DF';
    c.beginPath();
    c.moveTo(f[0][0], f[0][1]);
    c.lineTo(f[1][0], f[1][1]);
    c.stroke();
    c.lineWidth = Math.max(1, s * 0.007);
    c.strokeStyle = 'rgba(60, 50, 45, 0.4)';
    c.stroke();
    c.restore();
    return { x: x0, y: y0, w: gc.ancho * s, h: gc.alto * s };
  }

  // Back of the pin (element reverso_pin), from the owner's photo: white
  // plastic rounded square with a thin silver edge outside, a raised outer
  // rim and a slightly recessed inner panel, and a straight silver pin bar
  // across it (hinge plate with a small hook on the left, catch plate on the
  // right). Purely decorative: drawn beside the front on the visible canvas
  // and in _vista_previa, never in the composition or the print files.
  function dibujarReverso(c, x, y, w, h, radioFraccion, sombra) {
    var s = Math.min(w, h);
    var r = s * radioFraccion;
    var plata = { metal: 'plata', color: '#C0C4C8' };
    c.save();
    if (sombra) aplicarSombra(c, sombra);
    var borde = c.createLinearGradient(x, y, x + w, y + h);
    borde.addColorStop(0, '#EEF0F2');
    borde.addColorStop(0.5, '#C3C7CC');
    borde.addColorStop(1, '#8D9298');
    c.fillStyle = borde;
    c.beginPath();
    trazarRedondeado(c, x, y, w, h, r);
    c.fill();
    c.restore();
    c.save();
    // white body (the raised rim)
    var e1 = s * 0.025;
    var cuerpo = c.createLinearGradient(x, y, x, y + h);
    cuerpo.addColorStop(0, '#FFFFFF');
    cuerpo.addColorStop(1, '#ECE9E5');
    c.fillStyle = cuerpo;
    c.beginPath();
    trazarRedondeado(c, x + e1, y + e1, w - 2 * e1, h - 2 * e1, Math.max(0, r - e1));
    c.fill();
    // recessed inner panel: shade on its top-left edge, light on the bottom-right
    var e2 = s * 0.13;
    var pw = w - 2 * e2;
    var ph = h - 2 * e2;
    c.fillStyle = '#F7F5F2';
    c.beginPath();
    trazarRedondeado(c, x + e2, y + e2, pw, ph, Math.max(0, r * 0.45));
    c.fill();
    var bisel = c.createLinearGradient(x + e2, y + e2, x + e2 + pw, y + e2 + ph);
    bisel.addColorStop(0, 'rgba(60, 50, 45, 0.22)');
    bisel.addColorStop(0.55, 'rgba(60, 50, 45, 0.06)');
    bisel.addColorStop(1, 'rgba(255, 255, 255, 0.95)');
    c.lineWidth = Math.max(1, s * 0.014);
    c.strokeStyle = bisel;
    c.stroke();
    // safety pin: hinge plate + hook (left), bar, catch plate (right)
    var lw = Math.max(1, s * 0.016);
    var yb = y + h * 0.42;
    c.fillStyle = metal(c, plata, yb - s * 0.04, yb + s * 0.04);
    c.beginPath();
    trazarRedondeado(c, x + w * 0.25, yb - s * 0.03, w * 0.08, s * 0.06, s * 0.008);
    c.fill();
    c.beginPath();
    trazarRedondeado(c, x + w * 0.68, yb - s * 0.032, w * 0.09, s * 0.064, s * 0.008);
    c.fill();
    c.strokeStyle = metal(c, plata, yb - lw, yb + lw);
    c.lineWidth = lw;
    c.lineCap = 'round';
    c.lineJoin = 'round';
    c.beginPath();
    c.moveTo(x + w * 0.3, yb);
    c.lineTo(x + w * 0.74, yb);
    c.stroke();
    c.lineWidth = lw * 0.8;
    c.beginPath();
    c.moveTo(x + w * 0.275, yb + s * 0.03);
    c.lineTo(x + w * 0.29, yb + s * 0.105);
    c.lineTo(x + w * 0.315, yb + s * 0.03);
    c.stroke();
    c.restore();
  }

  function elemento(g, forma) {
    var lista = (g.decoracion && g.decoracion.elementos) || [];
    for (var i = 0; i < lista.length; i++) if (lista[i].forma === forma) return lista[i];
    return null;
  }

  // Pieces that cast a soft drop shadow under them (Pin, Separador). The composition
  // has no room for it, so it is added when the composition is shown in the
  // preview and when _vista_previa is encoded; never in the print files.
  function conSombra(g) {
    return !!(elemento(g, 'pelicula') || elemento(g, 'reverso_pin') || elemento(g, 'doblez') || elemento(g, 'clip_abierto'));
  }

  function aplicarSombra(c, tam) {
    c.shadowColor = 'rgba(59, 42, 34, 0.32)';
    c.shadowBlur = tam;
    c.shadowOffsetX = 0;
    c.shadowOffsetY = tam * 0.35;
  }

  // Back view size and overlap, as fractions of the front's side
  function medidasReverso(rv) {
    var escala = Math.min(0.9, Math.max(0.3, Number(rv.escala) || 0.6));
    var solape = Math.min(escala * 0.5, Math.max(0, Number(rv.solape) || 0.12));
    return { escala: escala, solape: solape, extra: escala - solape };
  }

  // Front + back in a box (px): the back goes to the right or below, whichever
  // lets the front be larger. Returns the front width and the side.
  function disposicionReverso(rv, ancho, alto, proporcion) {
    var m = medidasReverso(rv);
    var derecha = Math.min(ancho / (1 + m.extra), alto * proporcion);
    var abajo = Math.min(ancho, (alto * proporcion) / (1 + m.extra));
    return derecha >= abajo ? { lado: 'derecha', ancho: derecha } : { lado: 'abajo', ancho: abajo };
  }

  // Position of the back next to a front drawn at (x, y, w, h): bottom
  // aligned on the right, or right aligned below, tucked slightly behind
  function rectReverso(rv, lado, x, y, w, h) {
    var m = medidasReverso(rv);
    if (lado === 'derecha') return { x: x + w * (1 - m.solape), y: y + h * (1 - m.escala), w: w * m.escala, h: h * m.escala };
    return { x: x + w * (1 - m.escala), y: y + h * (1 - m.solape), w: w * m.escala, h: h * m.escala };
  }

  function vistaTransparente() {
    return TIPOS_VISTA_PNG.indexOf(datos.tipo) !== -1;
  }

  // What _vista_previa is encoded from: the composition, or (pieces with a
  // shadow) a slightly larger copy of it with the drop shadow and, for the
  // Pin, the back view on the right. White behind it only for JPEG; a PNG
  // keeps the transparent background.
  function fuenteVistaPrevia(g) {
    if (!conSombra(g)) return composicion;
    var margen = Math.round(composicion.width * 0.06);
    var clip = elemento(g, 'clip_abierto');
    if (clip) {
      var gc = geometriaClip(clip, g.alto / g.ancho);
      var lienzoClip = document.createElement('canvas');
      lienzoClip.width = Math.round(gc.ancho * composicion.width) + 2 * margen;
      lienzoClip.height = Math.round(gc.alto * composicion.width) + 2 * margen;
      var cc = lienzoClip.getContext('2d');
      if (!vistaTransparente()) {
        cc.fillStyle = '#FFFFFF';
        cc.fillRect(0, 0, lienzoClip.width, lienzoClip.height);
      }
      dibujarClip(cc, clip, g, margen, margen, composicion.width, margen * 0.6);
      return lienzoClip;
    }
    var rv = elemento(g, 'reverso_pin');
    var extra = rv ? medidasReverso(rv).extra : 0;
    var c = document.createElement('canvas');
    c.width = Math.round(composicion.width * (1 + extra)) + 2 * margen;
    c.height = composicion.height + 2 * margen;
    var cx = c.getContext('2d');
    if (!vistaTransparente()) {
      cx.fillStyle = '#FFFFFF';
      cx.fillRect(0, 0, c.width, c.height);
    }
    if (rv) {
      var rr = rectReverso(rv, 'derecha', margen, margen, composicion.width, composicion.height);
      dibujarReverso(cx, rr.x, rr.y, rr.w, rr.h, fraccionRadio(g), margen * 0.6);
    }
    cx.save();
    aplicarSombra(cx, margen * 0.6);
    cx.drawImage(composicion, margen, margen);
    cx.restore();
    return c;
  }

  // Corner radius of the piece as a fraction of its side (for the back view)
  function fraccionRadio(g) {
    var v = g.ventanas[0];
    var r = v && Number(v.radio_esquinas_cm) > 0 ? Number(v.radio_esquinas_cm) : 0;
    return Math.min(0.5, r / Math.min(g.ancho, g.alto));
  }

  // Clear acrylic photo holder, real silhouette (owner's photos): body with
  // rounded corners, sloping shoulders up to a narrow neck with a hole for
  // the small ring. Sizes in cm from the element (cuello, radio_cm…).
  function geometriaAcrilico(e, g, cw, ch) {
    var p = rectPx(e, cw, ch);
    var cuello = e.cuello || {};
    var a = {
      x: p.x,
      y: p.y,
      w: p.w,
      h: p.h,
      cx: p.x + p.w / 2,
      r: Math.min(cmAPx(e.radio_cm || 0.25, g, cw), p.w / 4),
      nw: cmAPx(cuello.ancho_cm || 1.1, g, cw),
      nh: cmAPx(cuello.alto_cm || 0.6, g, cw),
      sh: cmAPx(cuello.hombro_cm || 0.35, g, cw),
    };
    a.cuerpoY = a.y + a.nh + a.sh;
    a.rn = Math.min(a.nw / 2, a.nh) * 0.6;
    a.agujero = { x: a.cx, y: a.y + a.nh * 0.5, r: cmAPx((e.agujero && e.agujero.radio_cm) || 0.15, g, cw) };
    return a;
  }

  function trazarAcrilico(c, a) {
    var L = a.x;
    var R = a.x + a.w;
    var B = a.y + a.h;
    var nL = a.cx - a.nw / 2;
    var nR = a.cx + a.nw / 2;
    var hombro = a.y + a.nh;
    c.moveTo(L, a.cuerpoY + a.r);
    c.arcTo(L, a.cuerpoY, nL, hombro, a.r * 0.6);
    c.lineTo(nL, hombro);
    c.arcTo(nL, a.y, a.cx, a.y, a.rn);
    c.arcTo(nR, a.y, nR, hombro, a.rn);
    c.lineTo(nR, hombro);
    c.arcTo(R, a.cuerpoY, R, a.cuerpoY + a.r, a.r * 0.6);
    c.arcTo(R, B, R - a.r, B, a.r);
    c.arcTo(L, B, L, B - a.r, a.r);
    c.closePath();
  }

  // Inner rim around the photo window (window enlarged by borde_cm)
  function rimAcrilico(e, g, cw, ch) {
    var v = rectPx(g.ventanas[0], cw, ch);
    var o = cmAPx((e.borde && e.borde.cm) || 0.12, g, cw);
    return { x: v.x - o, y: v.y - o, w: v.w + 2 * o, h: v.h + 2 * o, v: v };
  }

  // Pass 1 (before the photo): almost clear body and the neck's hole
  function dibujarAcrilicoBase(e, g, cw, ch) {
    var a = geometriaAcrilico(e, g, cw, ch);
    cctx.save();
    cctx.beginPath();
    trazarAcrilico(cctx, a);
    cctx.fillStyle = 'rgba(255, 255, 255, 0.22)';
    cctx.fill();
    cctx.beginPath();
    cctx.arc(a.agujero.x, a.agujero.y, a.agujero.r, 0, Math.PI * 2);
    cctx.fillStyle = 'rgba(59, 42, 34, 0.10)';
    cctx.fill();
    cctx.lineWidth = Math.max(1, cw * 0.003);
    cctx.strokeStyle = 'rgba(59, 42, 34, 0.40)';
    cctx.stroke();
    cctx.restore();
  }

  // Pass 2 (after the photo): crisp bright edges, the inner rim, the bottom
  // notch and a soft shine — all on the acrylic band, never over the photo
  function dibujarAcrilicoBrillo(e, g, cw, ch) {
    var a = geometriaAcrilico(e, g, cw, ch);
    var rim = rimAcrilico(e, g, cw, ch);
    var fino = Math.max(1, cw * 0.0025);
    cctx.save();

    // Band = holder minus the rim rectangle (even-odd), so the photo stays clean
    cctx.beginPath();
    trazarAcrilico(cctx, a);
    cctx.rect(rim.x, rim.y, rim.w, rim.h);
    cctx.save();
    cctx.clip('evenodd');
    var banda = cctx.createLinearGradient(a.x, a.y, a.x + a.w, a.y + a.h);
    banda.addColorStop(0, 'rgba(255, 255, 255, 0.38)');
    banda.addColorStop(0.45, 'rgba(255, 255, 255, 0.10)');
    banda.addColorStop(1, 'rgba(255, 255, 255, 0.30)');
    cctx.fillStyle = banda;
    cctx.fillRect(a.x, a.y, a.w, a.h);
    cctx.restore();

    // Outer edge: thin dark line + bright inner line (crisp acrylic)
    cctx.beginPath();
    trazarAcrilico(cctx, a);
    cctx.lineWidth = fino * 1.4;
    cctx.strokeStyle = 'rgba(59, 42, 34, 0.45)';
    cctx.stroke();
    cctx.save();
    cctx.clip();
    cctx.beginPath();
    trazarAcrilico(cctx, a);
    cctx.lineWidth = fino * 4;
    cctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
    cctx.stroke();
    cctx.restore();

    // Inner rim: bright line with a thin shadow on its inside
    cctx.lineWidth = fino * 2.2;
    cctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
    cctx.strokeRect(rim.x, rim.y, rim.w, rim.h);
    cctx.lineWidth = fino;
    cctx.strokeStyle = 'rgba(59, 42, 34, 0.30)';
    cctx.strokeRect(rim.v.x - fino / 2, rim.v.y - fino / 2, rim.v.w + fino, rim.v.h + fino);

    // Small notch at the bottom centre of the rim
    var rm = cmAPx((e.muesca && e.muesca.radio_cm) || 0.12, g, cw);
    cctx.beginPath();
    cctx.arc(a.cx, rim.y + rim.h, rm, 0, Math.PI);
    cctx.lineWidth = fino * 1.6;
    cctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
    cctx.stroke();
    cctx.beginPath();
    cctx.arc(a.cx, rim.y + rim.h, rm + fino, 0.15 * Math.PI, 0.85 * Math.PI);
    cctx.lineWidth = fino;
    cctx.strokeStyle = 'rgba(59, 42, 34, 0.35)';
    cctx.stroke();

    cctx.restore();
  }

  function dibujarDecoracion(g, cw, ch) {
    var d = g.decoracion;
    (d.elementos || []).forEach(function (e) {
      // Known shapes only; any other (e.g. an old "pompon" or "cadena") is
      // ignored. The fur pompón (pompon_pelo) is drawn over the photo pass.
      if (e.forma === 'aro') dibujarAro(e, g, cw, ch);
      else if (e.forma === 'acrilico') dibujarAcrilicoBase(e, g, cw, ch);
      else if (e.forma === 'correa') dibujarCorrea(e, g, cw, ch);
      else if (e.forma === 'eslabon') dibujarEslabon(e, g, cw, ch);
      else if (e.forma === 'cadena_ovalada') dibujarCadena(e, g, cw, ch);
    });
    if (d.fondo) {
      cctx.fillStyle = d.fondo;
      cctx.fillRect(0, 0, cw, ch);
    }
    var grosor = Math.max(1, ((Number(d.contorno_cm) || 0.03) / g.ancho) * cw);
    (d.huecos || []).forEach(function (hueco) {
      var p = rectPx(hueco, cw, ch);
      if (d.fondo_hueco) {
        cctx.fillStyle = d.fondo_hueco;
        cctx.fillRect(p.x, p.y, p.w, p.h);
      }
      if (d.contorno) {
        cctx.strokeStyle = d.contorno;
        cctx.lineWidth = grosor;
        cctx.strokeRect(p.x + grosor / 2, p.y + grosor / 2, p.w - grosor, p.h - grosor);
      }
    });
  }

  // True when nothing is drawn in the composition under a box given in CSS
  // px of the preview (used to place the "Ejemplo" chip). If the pixels can't
  // be read, it answers false (the chip then goes on the photo's corner).
  function zonaVacia(caja, ancho, alto, porCss, region, escala, ox, oy) {
    try {
      var x = Math.max(0, Math.floor(region.x + (caja.x * porCss - ox) / escala));
      var y = Math.max(0, Math.floor(region.y + (caja.y * porCss - oy) / escala));
      var w = Math.max(1, Math.ceil((ancho * porCss) / escala));
      var h = Math.max(1, Math.ceil((alto * porCss) / escala));
      var datosZona = cctx.getImageData(x, y, Math.min(w, composicion.width - x), Math.min(h, composicion.height - y)).data;
      for (var i = 3; i < datosZona.length; i += 16) if (datosZona[i] > 8) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  // Placeholder text centred in a window, always inside it: at most the given
  // size, smaller if needed; on two lines when one would get too small
  // (narrow windows such as the keychain's acrylic holder)
  function escribirAjustado(texto, v, tamanoMax) {
    var disponible = v.w * 0.84;
    var fuente = function (px) {
      return '500 ' + Math.max(1, Math.round(px)) + 'px "DM Sans", sans-serif';
    };
    var lineas = [texto];
    var tam = tamanoMax;
    cctx.font = fuente(tam);
    var ancho = cctx.measureText(texto).width;
    if (ancho > disponible) {
      var espacio = texto.indexOf(' ', Math.floor(texto.length / 2) - 1);
      if (espacio === -1) espacio = texto.lastIndexOf(' ');
      // two lines read better than one tiny line
      if (espacio > 0 && (tam * disponible) / ancho < tamanoMax * 0.7) {
        lineas = [texto.slice(0, espacio), texto.slice(espacio + 1)];
      }
      var masAncha = Math.max.apply(null, lineas.map(function (l) { return cctx.measureText(l).width; }));
      if (masAncha > disponible) tam = (tam * disponible) / masAncha;
    }
    cctx.font = fuente(tam);
    var alto = tam * 1.25;
    var y0 = v.y + v.h / 2 - (alto * (lineas.length - 1)) / 2;
    lineas.forEach(function (l, k) {
      cctx.fillText(l, v.x + v.w / 2, y0 + k * alto);
    });
  }

  // Draws the whole product (frame, slots, phrase) onto the composition canvas
  function componer(g) {
    var cw = composicion.width;
    var ch = composicion.height;
    cctx.clearRect(0, 0, cw, ch);
    if (g.marco) {
      cctx.fillStyle = datos.colorMarco; // the white border is part of the product
      cctx.fillRect(0, 0, cw, ch);
    }
    if (g.decoracion) dibujarDecoracion(g, cw, ch);
    var encima = (g.decoracion && g.decoracion.elementos) || [];

    g.ventanas.forEach(function (ventana, i) {
      var v = rectPx(ventana, cw, ch);
      var cas = estado.casillas[i];
      var radio = radioVentana(ventana, v, g);
      // Light shadow of a magnet sitting in its pocket
      if (g.decoracion && conRelieve()) {
        cctx.save();
        cctx.fillStyle = 'rgba(0, 0, 0, 0.18)';
        cctx.beginPath();
        trazarRedondeado(cctx, v.x + v.w * 0.012, v.y + v.w * 0.02, v.w, v.h, radio);
        cctx.fill();
        cctx.restore();
      }
      cctx.save();
      trazarMascara(cctx, v, radio);
      cctx.clip();
      if (cas.cache) {
        cctx.drawImage(cas.cache, v.x, v.y, v.w, v.h);
      } else {
        cctx.fillStyle = datos.colorFondoVentana;
        cctx.fillRect(v.x, v.y, v.w, v.h);
        cctx.fillStyle = datos.colorTexto;
        cctx.textAlign = 'center';
        cctx.textBaseline = 'middle';
        var marcador = varias(g) ? plantilla(t.fotoN, { n: i + 1 }) : t.fotoEjemploPendiente;
        escribirAjustado(marcador, v, Math.min(v.w * 0.09, cw * 0.045));
      }
      cctx.restore();
      if (conRelieve()) dibujarDomo(cctx, v, radio);
    });

    // Elements drawn over the photos (the acrylic's edge and shine, the
    // Pin's film, the Separador's fold, the keychain's pompón in front of
    // the holder's edge)
    encima.forEach(function (e) {
      if (e.forma === 'acrilico') dibujarAcrilicoBrillo(e, g, cw, ch);
      else if (e.forma === 'pompon_pelo') dibujarPompon(e, g, cw, ch);
      else if (e.forma === 'pelicula') dibujarPelicula(e, g, cw, ch);
      else if (e.forma === 'doblez') dibujarDoblez(e, g, cw, ch);
    });

    // Phrase in the bottom strip
    var avisoFrase = raiz.querySelector('[data-aviso="frase"]');
    if (avisoFrase) avisoFrase.hidden = true;
    if (g.modo === 'con_frase' && g.frase) {
      var f = rectPx(g.frase, cw, ch);
      var texto = estado.frase || t.fraseEjemplo;
      var familia = estado.fuente || 'DM Sans';
      var peso = PESOS[familia] || 400;
      var tamano = f.h * 0.62;
      cctx.font = peso + ' ' + tamano + 'px "' + familia + '"';
      while (cctx.measureText(texto).width > f.w && tamano > 4) {
        tamano *= 0.95;
        cctx.font = peso + ' ' + tamano + 'px "' + familia + '"';
      }
      cctx.fillStyle = estado.frase ? estado.color || datos.colorTexto : 'rgba(59, 42, 34, 0.35)';
      cctx.textAlign = 'center';
      cctx.textBaseline = 'middle';
      cctx.fillText(texto, f.x + f.w / 2, f.y + f.h / 2);

      // Printed font size in mm, from the real outer height
      var mm = (tamano * g.alto * 10) / ch;
      if (estado.frase && avisoFrase && mm < MM_MINIMO_FRASE) {
        avisoFrase.textContent = t.frasePequena;
        avisoFrase.hidden = false;
      }
    }
  }

  // Area of the composition shown on screen: everything, or only the active
  // slot (plus a margin) while adjusting a multi-slot product or a piece
  // drawn with accessories (keychain), where the photo is small in the box
  function regionVisible(g) {
    var cw = composicion.width;
    var ch = composicion.height;
    var conAccesorios = !!(g.decoracion && g.decoracion.elementos);
    if (!(estado.ajustando && (varias(g) || conAccesorios))) return { x: 0, y: 0, w: cw, h: ch };
    var v = rectPx(g.ventanas[estado.activa], cw, ch);
    var margen = conAccesorios ? v.w * 0.12 : g.ventanas[estado.activa].x * cw;
    var x = Math.max(0, v.x - margen);
    var y = Math.max(0, v.y - margen);
    return { x: x, y: y, w: Math.min(cw, v.x + v.w + margen) - x, h: Math.min(ch, v.y + v.h + margen) - y };
  }

  // Canvas resolution follows its fixed CSS box (capped for performance)
  var marcoLienzo = raiz.querySelector('[data-lienzo-marco]');
  function ajustarTamanoLienzo() {
    var ancho = marcoLienzo.clientWidth;
    var alto = marcoLienzo.clientHeight;
    if (!ancho || !alto) {
      // the box can report 0 while laid out; fall back to the canvas's own size
      var caja = lienzo.getBoundingClientRect();
      ancho = Math.round(caja.width);
      alto = Math.round(caja.height);
    }
    if (!ancho || !alto) return;
    var densidad = Math.min(window.devicePixelRatio || 1, DENSIDAD_MAXIMA);
    var escalaMax = Math.min(1, LADO_MAXIMO_LIENZO / (Math.max(ancho, alto) * densidad));
    var w = Math.round(ancho * densidad * escalaMax);
    var h = Math.round(alto * densidad * escalaMax);
    if (lienzo.width !== w || lienzo.height !== h) {
      lienzo.width = w;
      lienzo.height = h;
    }
  }

  // --- Gallery (option C): product photos first, the live design as one more item ---
  var fotosGaleria = Array.prototype.slice.call(raiz.querySelectorAll('[data-galeria-foto]'));
  var minisGaleria = Array.prototype.slice.call(raiz.querySelectorAll('[data-galeria-mini]'));
  var miniDiseno = raiz.querySelector('[data-galeria-mini="diseno"]');
  var lienzoMini = raiz.querySelector('[data-galeria-mini-lienzo]');

  function mostrarGaleria(objetivo) {
    if (objetivo !== 'diseno' && !fotosGaleria.some(function (f) { return f.getAttribute('data-galeria-foto') === objetivo; })) return;
    estado.galeria = objetivo;
    raiz.classList.toggle('personalizador--viendo-foto', objetivo !== 'diseno');
    fotosGaleria.forEach(function (f) {
      f.hidden = f.getAttribute('data-galeria-foto') !== objetivo;
    });
    minisGaleria.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-galeria-mini') === objetivo ? 'true' : 'false');
    });
  }

  // "Tu diseño" appears once a photo is chosen; without photos the gallery
  // goes back to the product's own photos. Its thumbnail copies the preview.
  function sincronizarGaleria() {
    if (!miniDiseno) return;
    var hay = hayFotos();
    miniDiseno.hidden = !hay;
    if (!hay && estado.galeria === 'diseno' && fotosGaleria.length) mostrarGaleria(fotoPorDefecto());
    if (hay && lienzoMini && lienzoMini.getContext && lienzo.width && lienzo.height) {
      var mc = lienzoMini.getContext('2d');
      var k = Math.min(lienzoMini.width / lienzo.width, lienzoMini.height / lienzo.height);
      var w = lienzo.width * k;
      var h = lienzo.height * k;
      mc.clearRect(0, 0, lienzoMini.width, lienzoMini.height);
      mc.drawImage(lienzo, (lienzoMini.width - w) / 2, (lienzoMini.height - h) / 2, w, h);
    }
  }

  minisGaleria.forEach(function (b) {
    b.addEventListener('click', function () {
      mostrarGaleria(b.getAttribute('data-galeria-mini'));
    });
  });

  // The gallery item showing a variant's own photo (its featured media), if any
  function fotoDeVariante(v) {
    if (!v || v.medio == null) return null;
    for (var i = 0; i < fotosGaleria.length; i++) {
      if (fotosGaleria[i].getAttribute('data-medio') === String(v.medio)) return fotosGaleria[i].getAttribute('data-galeria-foto');
    }
    return null;
  }

  function fotoPorDefecto() {
    return fotoDeVariante(estado.variante) || 'foto-0';
  }

  function dibujar() {
    dibujarVista();
    sincronizarGaleria();
  }

  function dibujarVista() {
    var g = geometria();
    raiz.querySelector('[data-sin-config]').hidden = !!g;
    lienzo.hidden = !g;
    if (!g) return;
    asegurarCasillas(g);

    // The canvas keeps the size of its fixed box; the visible region is
    // fitted inside it (contain: centred, undistorted). The composition is
    // sized so that region lands 1:1 on the canvas (crisp, no resampling).
    ajustarTamanoLienzo();
    if (prepararComposicion(g, composicion.width)) actualizarCaches(false);
    var r0 = regionVisible(g);
    var fw = r0.w / composicion.width;
    var fh = r0.h / composicion.height;
    var sombra = conSombra(g) && !estado.ajustando;
    var margen = Math.round(Math.min(lienzo.width, lienzo.height) * (sombra ? 0.07 : 0.03));
    var cajaW = lienzo.width - 2 * margen;
    var cajaH = lienzo.height - 2 * margen;
    // Pin: the back view beside the front (not while adjusting)
    var rv = estado.ajustando ? null : elemento(g, 'reverso_pin');
    var disp = rv ? disposicionReverso(rv, cajaW, cajaH, g.ancho / g.alto) : null;
    // Separador: the open, slightly rotated clip (not while adjusting)
    var clip = estado.ajustando ? null : elemento(g, 'clip_abierto');
    var gc = clip ? geometriaClip(clip, g.alto / g.ancho) : null;
    var anchoClip = gc ? Math.min(cajaW / gc.ancho, cajaH / gc.alto) : 0;
    var objetivo = disp ? disp.ancho / fw : gc ? anchoClip / fw : Math.min(cajaW / fw, ((cajaH / fh) * g.ancho) / g.alto);
    if (prepararComposicion(g, objetivo)) actualizarCaches(false);
    componer(g);
    var region = regionVisible(g);
    var escala = disp ? disp.ancho / region.w : gc ? anchoClip / region.w : Math.min(cajaW / region.w, cajaH / region.h);
    var frenteW = region.w * escala;
    var frenteH = region.h * escala;
    var extraRv = rv ? medidasReverso(rv).extra : 0;
    var grupoW = disp && disp.lado === 'derecha' ? frenteW * (1 + extraRv) : frenteW;
    var grupoH = disp && disp.lado === 'abajo' ? frenteH * (1 + extraRv) : frenteH;
    // Desktop (two columns): the product sits at the top of its tall sticky
    // box, level with the title column; on mobile it stays centred
    var arriba = !!(window.matchMedia && window.matchMedia('(min-width: 1024px)').matches);
    var ox = (lienzo.width - grupoW) / 2;
    var oy = arriba ? margen : (lienzo.height - grupoH) / 2;
    var reverso = disp ? rectReverso(rv, disp.lado, ox, oy, frenteW, frenteH) : null;
    if (reverso) reverso.lado = disp.lado;
    ctx.clearRect(0, 0, lienzo.width, lienzo.height);
    var clipCaja = null;
    if (gc) {
      var x0 = (lienzo.width - gc.ancho * frenteW) / 2;
      var y0 = arriba ? margen : (lienzo.height - gc.alto * frenteW) / 2;
      clipCaja = dibujarClip(ctx, clip, g, x0, y0, frenteW, margen * 0.6);
      // the projected face's box (for the chip; adjusting is always frontal)
      var cxs = gc.cara.map(function (p) { return p[0]; });
      var cys = gc.cara.map(function (p) { return p[1]; });
      ox = x0 + (Math.min.apply(null, cxs) - gc.minX) * frenteW;
      oy = y0 + (Math.min.apply(null, cys) - gc.minY) * frenteW;
    } else {
      if (reverso) dibujarReverso(ctx, reverso.x, reverso.y, reverso.w, reverso.h, fraccionRadio(g), margen * 0.6);
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      if (sombra) aplicarSombra(ctx, margen * 0.6);
      ctx.drawImage(composicion, region.x, region.y, region.w, region.h, ox, oy, region.w * escala, region.h * escala);
      ctx.restore();
    }
    // decoration beside or around the face (Pin back, open clip): part of the product for the chip
    var adorno = reverso || clipCaja;
    estado.vista = { region: region, escala: escala, ox: ox, oy: oy, reverso: reverso, clip: clipCaja };

    // Active slot highlighted (dashed while adjusting)
    if (varias(g) || estado.ajustando) {
      var ventanaActiva = g.ventanas[estado.activa];
      var v = rectPx(ventanaActiva, composicion.width, composicion.height);
      var radio = radioVentana(ventanaActiva, v, g) * escala;
      var lw = Math.max(2, lienzo.width * 0.006);
      ctx.save();
      ctx.strokeStyle = '#B5573A';
      ctx.lineWidth = lw;
      if (estado.ajustando) ctx.setLineDash([lienzo.width * 0.02, lienzo.width * 0.012]);
      trazarMascara(
        ctx,
        { x: ox + (v.x - region.x) * escala + lw / 2, y: oy + (v.y - region.y) * escala + lw / 2, w: v.w * escala - lw, h: v.h * escala - lw },
        Math.max(0, radio - lw / 2)
      );
      ctx.stroke();
      ctx.restore();
    }

    // "Ejemplo" chip, never over the rings, strap or rim: in the free space
    // beside or above the drawn product when it fits; else in a corner of
    // the product where nothing is drawn; else on the photo's own corner
    // (the chip labels the sample photo)
    var chip = raiz.querySelector('[data-etiqueta-ejemplo]');
    chip.hidden = hayFotos() || estado.ajustando;
    var porCss = lienzo.width / (lienzo.getBoundingClientRect().width || lienzo.width);
    var hueco = 8;
    var producto = { x: ox / porCss, y: oy / porCss, w: (region.w * escala) / porCss, h: (region.h * escala) / porCss };
    if (adorno) {
      // the face and its decoration (Pin back, open clip) count as the product
      var izquierdaP = Math.min(producto.x, adorno.x / porCss);
      var arribaP = Math.min(producto.y, adorno.y / porCss);
      var derecha = Math.max(producto.x + producto.w, (adorno.x + adorno.w) / porCss);
      var abajo = Math.max(producto.y + producto.h, (adorno.y + adorno.h) / porCss);
      producto = { x: izquierdaP, y: arribaP, w: derecha - izquierdaP, h: abajo - arribaP };
    }
    var chipAncho = chip.offsetWidth || 0;
    var chipAlto = chip.offsetHeight || 0;
    var posicion = null;
    var lugar = '';
    if (producto.x >= chipAncho + 2 * hueco) {
      posicion = { x: hueco, y: producto.y + hueco };
      lugar = 'al lado';
    } else if (producto.y >= chipAlto + 2 * hueco) {
      posicion = { x: producto.x + hueco, y: hueco };
      lugar = 'arriba';
    } else {
      var esquinas = [
        { x: producto.x + hueco, y: producto.y + hueco },
        { x: producto.x + producto.w - chipAncho - hueco, y: producto.y + hueco },
        { x: producto.x + hueco, y: producto.y + producto.h - chipAlto - hueco },
        { x: producto.x + producto.w - chipAncho - hueco, y: producto.y + producto.h - chipAlto - hueco },
      ];
      for (var k = 0; k < esquinas.length && !posicion; k++) {
        if (zonaVacia(esquinas[k], chipAncho, chipAlto, porCss, region, escala, ox, oy)) {
          posicion = esquinas[k];
          lugar = 'esquina vacía';
        }
      }
      if (!posicion) {
        var vf = rectPx(g.ventanas[estado.activa] || g.ventanas[0], composicion.width, composicion.height);
        posicion = { x: (ox + (vf.x - region.x) * escala) / porCss + hueco, y: (oy + (vf.y - region.y) * escala) / porCss + hueco };
        lugar = 'esquina de la foto';
      }
    }
    estado.chipEjemplo = { x: posicion.x, y: posicion.y, w: chipAncho, h: chipAlto, lugar: lugar, producto: producto };
    chip.style.left = Math.round(posicion.x) + 'px';
    chip.style.top = Math.round(posicion.y) + 'px';
    actualizarMiniaturas(g);
    describir(g);
  }

  function describir(g) {
    var modo = g.modo === 'con_frase' ? t.modoConFrase : t.modoSoloFoto;
    var texto = plantilla(t.descripcionVista, { tamano: nombreTamano(), modo: modo });
    var elegidas = estado.casillas.slice(0, g.ventanas.length).filter(function (c) {
      return c.foto;
    }).length;
    if (varias(g)) texto += ' ' + plantilla(t.fotosElegidas, { n: elegidas, total: g.ventanas.length });
    else if (!elegidas) texto += ' ' + t.sinFoto + '.';
    if (g.modo === 'con_frase' && estado.frase) {
      texto += ' ' + plantilla(t.descripcionFrase, { frase: estado.frase, fuente: estado.fuente, color: estado.colorNombre });
    }
    if (estado.colorAccesorio) {
      texto += ' ' + plantilla(t.descripcionAccesorio, { titulo: tituloColor(), color: estado.colorAccesorio.nombre });
    }
    lienzo.setAttribute('aria-label', texto);
  }

  // --- Slot thumbnails (multi-slot products) ---

  var contenedorCasillas = raiz.querySelector('[data-casillas]');
  var ayudaCasillas = raiz.querySelector('[data-casillas-ayuda]');

  function construirMiniaturas(g) {
    if (!contenedorCasillas) return;
    var n = varias(g) ? g.ventanas.length : 0;
    contenedorCasillas.hidden = !n;
    if (ayudaCasillas) ayudaCasillas.hidden = !n;
    if (contenedorCasillas.children.length === n) return;
    contenedorCasillas.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'personalizador__casilla';
      boton.dataset.casilla = i;
      var mini = document.createElement('canvas');
      mini.width = 96;
      mini.height = 96;
      mini.setAttribute('aria-hidden', 'true');
      var numero = document.createElement('span');
      numero.className = 'personalizador__casilla-numero';
      numero.setAttribute('aria-hidden', 'true');
      numero.textContent = i + 1;
      var etiqueta = document.createElement('span');
      etiqueta.className = 'visually-hidden';
      boton.append(mini, numero, etiqueta);
      boton.addEventListener('click', function (e) {
        seleccionar(Number(e.currentTarget.dataset.casilla));
      });
      contenedorCasillas.appendChild(boton);
    }
  }

  function actualizarMiniaturas(g) {
    construirMiniaturas(g);
    if (!contenedorCasillas || contenedorCasillas.hidden) return;
    Array.from(contenedorCasillas.children).forEach(function (boton, i) {
      var cas = estado.casillas[i];
      var mini = boton.querySelector('canvas');
      var p = proporcionVentana(g, i);
      mini.height = Math.round(mini.width / p);
      var mctx = mini.getContext('2d');
      if (cas.foto && cas.cache) {
        mctx.drawImage(cas.cache, 0, 0, mini.width, mini.height);
      } else {
        mctx.fillStyle = datos.colorFondoVentana;
        mctx.fillRect(0, 0, mini.width, mini.height);
      }
      boton.setAttribute('aria-pressed', i === estado.activa ? 'true' : 'false');
      boton.classList.toggle('personalizador__casilla--aviso', !!(cas.aviso));
      boton.querySelector('.visually-hidden').textContent =
        plantilla(t.fotoN, { n: i + 1 }) + ', ' + (cas.foto ? t.casillaElegida : t.casillaVacia);
    });
  }

  function textoElegir() {
    var g = geometria();
    var cas = estado.casillas[estado.activa];
    var tiene = cas && cas.foto;
    if (varias(g)) return plantilla(tiene ? t.cambiarFotoN : t.elegirFotoN, { n: estado.activa + 1 });
    return tiene ? t.cambiarFoto : t.elegirFoto;
  }

  function actualizarControlesFoto() {
    raiz.querySelector('[data-texto-elegir]').textContent = textoElegir();
    var cas = estado.casillas[estado.activa];
    raiz.querySelector('[data-ajustar]').hidden = !(cas && cas.foto) || estado.ajustando;
  }

  function seleccionar(i) {
    var g = geometria();
    if (!g) return;
    estado.activa = limitar(i, 0, g.ventanas.length - 1);
    if (estado.ajustando && !estado.casillas[estado.activa].foto) salirAjuste(false);
    actualizarControlesFoto();
    dibujar();
    if (estado.ajustando) programarAnuncio();
  }

  // --- Messages and quality ---

  function mostrarAviso(nombre, texto) {
    var el = raiz.querySelector('[data-aviso="' + nombre + '"]');
    if (!el) return;
    el.textContent = texto || '';
    el.hidden = !texto;
  }

  // Per slot: the crop's pixels on the window's short side vs the minimum
  // (px_minimo_lado of the mode in adina.casillas, else the variant metafield)
  function revisarCalidad() {
    var lista = raiz.querySelector('[data-avisos-calidad]');
    var g = geometria();
    if (!lista || !g) return;
    lista.innerHTML = '';
    g.ventanas.forEach(function (_, i) {
      var cas = estado.casillas[i];
      cas.aviso = false;
      if (!cas.foto) return;
      var p = proporcionVentana(g, i);
      var r = recorteCasilla(i, g);
      var ladoCorto = p < 1 ? r.w : r.h;
      var mensajes = [];
      if (g.pxMinimo && ladoCorto < g.pxMinimo) {
        mensajes.push(datos.varianteUnica ? t.avisoBorrosaPieza : plantilla(t.avisoBorrosa, { tamano: estado.variante.titulo }));
      }
      if ((r.w * r.h) / (cas.foto.naturalWidth * cas.foto.naturalHeight) < 0.55) mensajes.push(t.avisoRecorte);
      mensajes.forEach(function (m) {
        var el = document.createElement('p');
        el.className = 'personalizador__aviso';
        el.textContent = varias(g) ? plantilla(t.avisoCasilla, { n: i + 1, aviso: m }) : m;
        lista.appendChild(el);
      });
      cas.aviso = mensajes.length > 0;
    });
    actualizarMiniaturas(g);
  }

  function cargarImagen(fuente) {
    return new Promise(function (resolver, rechazar) {
      var img = new Image();
      img.onload = function () {
        resolver(img);
      };
      img.onerror = function () {
        rechazar(new Error('decode'));
      };
      img.src = fuente;
    });
  }

  // Decode once up front, but never wait more than LIMITE_DECODIFICAR ms:
  // in some browsers decode() never settles (e.g. a page that is not
  // displayed). The image is already loaded, so drawing works either way.
  var LIMITE_DECODIFICAR = 1500;
  function decodificar(img) {
    if (!img.decode) return Promise.resolve();
    return Promise.race([
      img.decode().catch(function () {}),
      new Promise(function (resolver) {
        setTimeout(resolver, LIMITE_DECODIFICAR);
      }),
    ]);
  }

  function liberar(cas) {
    if (cas.foto && cas.foto.src.indexOf('blob:') === 0) URL.revokeObjectURL(cas.foto.src);
    cas.foto = null;
    cas.archivo = null;
    cas.ajuste = null;
    cas.aviso = false;
  }

  async function alElegirFoto(archivo) {
    quitarResaltado();
    // A new photo means a new design in progress: the drawer's "Crear otro"
    // must not clear it any more (it goes to the Crear page instead)
    agregadoAqui = false;
    mostrarAviso('error', '');
    if (!archivo) return;
    var g = geometria();
    if (!g) return;
    asegurarCasillas(g);
    var url = URL.createObjectURL(archivo);
    var img;
    try {
      img = await cargarImagen(url);
      // Decode once now, so later draws and the add-to-cart files don't decode again
      await decodificar(img);
    } catch (e) {
      URL.revokeObjectURL(url);
      mostrarAviso('error', t.errorLectura);
      return;
    }
    var cas = estado.casillas[estado.activa];
    liberar(cas);
    cas.foto = img;
    cas.archivo = archivo;
    actualizarCaches(true);
    // Multi-slot: move on to the next empty slot (not while adjusting)
    if (varias(g) && !estado.ajustando) {
      for (var k = 1; k < g.ventanas.length; k++) {
        var j = (estado.activa + k) % g.ventanas.length;
        if (!estado.casillas[j].foto) {
          estado.activa = j;
          break;
        }
      }
    }
    actualizarControlesFoto();
    mostrarGaleria('diseno');
    dibujar();
    revisarCalidad();
  }

  function refrescarTodo() {
    actualizarCaches(false);
    dibujar();
    revisarCalidad();
    actualizarControlesFoto();
  }

  function alCambiarVariante(id) {
    var v = variantePorId(id);
    if (!v) return;
    estado.variante = v;
    // The gallery follows the variant's photo, unless the customer is
    // looking at their own design (never pulled away from it)
    if (fotosGaleria.length && !(estado.galeria === 'diseno' && hayFotos())) {
      var fotoVariante = fotoDeVariante(v);
      if (fotoVariante) mostrarGaleria(fotoVariante);
    }
    raiz.querySelector('[data-precio]').textContent = v.precio;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
    actualizarPasoColor();
    refrescarTodo();
  }

  // --- Accessory colour step (adina.colores_accesorio on the variant) ---

  function coloresVariante() {
    var c = estado.variante && estado.variante.colores;
    if (!c || !Array.isArray(c.colores)) return [];
    return c.colores.filter(function (x) {
      return x && x.nombre && /^#[0-9A-Fa-f]{6}$/.test(x.hex || '');
    });
  }

  function tituloColor() {
    var c = estado.variante && estado.variante.colores;
    return c && c.accesorio === 'pompon' ? t.colorPompon : t.colorLazo;
  }

  // Builds the swatches for the selected variant; keeps the same colour name
  // when switching styles if it exists there, else picks the first one
  function actualizarPasoColor() {
    var paso = raiz.querySelector('[data-paso-color]');
    var cont = raiz.querySelector('[data-colores-accesorio]');
    if (!paso || !cont) return;
    var lista = coloresVariante();
    paso.hidden = !lista.length;
    cont.innerHTML = '';
    if (!lista.length) {
      estado.colorAccesorio = null;
      return;
    }
    var actual = estado.colorAccesorio
      ? lista.find(function (x) {
          return x.nombre === estado.colorAccesorio.nombre;
        })
      : null;
    estado.colorAccesorio = actual || lista[0];
    cont.setAttribute('aria-label', tituloColor());
    lista.forEach(function (x, i) {
      var etiqueta = document.createElement('label');
      etiqueta.className = 'personalizador__color';
      etiqueta.style.setProperty('--muestra', x.hex);
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'color-accesorio';
      radio.value = x.hex;
      radio.className = 'visually-hidden';
      radio.checked = x === estado.colorAccesorio;
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        estado.colorAccesorio = x;
        actualizarTituloColor();
        dibujar();
      });
      var muestra = document.createElement('span');
      muestra.className = 'personalizador__muestra';
      muestra.setAttribute('aria-hidden', 'true');
      var nombre = document.createElement('span');
      nombre.className = 'visually-hidden';
      nombre.textContent = x.nombre;
      etiqueta.append(radio, muestra, nombre);
      cont.appendChild(etiqueta);
    });
    actualizarTituloColor();
  }

  function actualizarTituloColor() {
    var titulo = raiz.querySelector('[data-titulo-color]');
    if (titulo && estado.colorAccesorio) {
      titulo.textContent = plantilla(t.colorElegido, { titulo: tituloColor(), color: estado.colorAccesorio.nombre });
    }
  }

  function actualizarContador() {
    var contador = raiz.querySelector('[data-contador]');
    if (contador) {
      contador.textContent = plantilla(t.contador, { actual: estado.frase.length, maximo: datos.fraseMax });
    }
  }

  function cargarFuentes() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all(
      Object.keys(PESOS).map(function (familia) {
        return document.fonts.load(PESOS[familia] + ' 32px "' + familia + '"').catch(function () {});
      })
    );
  }

  // --- Upload and add to cart ---

  // Storage module. Option D (Shopify native upload): the Blob travels in
  // the add-to-cart FormData and Shopify turns it into a CDN URL on the
  // line item. To switch to Cloudinary (option A), replace `adjuntar` with
  // one that uploads the Blob and appends the returned URL string instead.
  var subidor = {
    nombre: 'shopify-nativo',
    adjuntar: function (formData, clave, blob, nombreArchivo) {
      formData.append(clave, blob, nombreArchivo);
      return Promise.resolve();
    },
  };

  function aJpeg(fuente, sx, sy, sw, sh, ladoMaximo, calidad) {
    return new Promise(function (resolver, rechazar) {
      var escala = Math.min(1, ladoMaximo / Math.max(sw, sh));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(sw * escala));
      c.height = Math.max(1, Math.round(sh * escala));
      var cx = c.getContext('2d');
      cx.fillStyle = '#FFFFFF'; // PNG transparency becomes white, not black
      cx.fillRect(0, 0, c.width, c.height);
      cx.drawImage(fuente, sx, sy, sw, sh, 0, 0, c.width, c.height);
      c.toBlob(
        function (blob) {
          if (blob) resolver(blob);
          else rechazar(new Error('toBlob'));
        },
        'image/jpeg',
        calidad
      );
    });
  }

  // Transparent PNG of the whole source, at most ancho px wide
  function aPng(fuente, ancho) {
    return new Promise(function (resolver, rechazar) {
      var escala = Math.min(1, ancho / fuente.width);
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(fuente.width * escala));
      c.height = Math.max(1, Math.round(fuente.height * escala));
      var cx = c.getContext('2d');
      cx.imageSmoothingEnabled = true;
      cx.imageSmoothingQuality = 'high';
      cx.drawImage(fuente, 0, 0, c.width, c.height);
      c.toBlob(function (blob) {
        if (blob) resolver(blob);
        else rechazar(new Error('toBlob'));
      }, 'image/png');
    });
  }

  // _vista_previa as a transparent PNG within VISTA_PNG_MAX (narrower if needed)
  async function vistaPng(fuente) {
    var blob = await aPng(fuente, fuente.width);
    for (var i = 0; i < ANCHOS_VISTA_PNG.length && blob.size > VISTA_PNG_MAX; i++) {
      if (ANCHOS_VISTA_PNG[i] < fuente.width) blob = await aPng(fuente, ANCHOS_VISTA_PNG[i]);
    }
    return blob;
  }

  // Print crop (_foto_recortada): the crop of the photo itself, at most
  // ladoMaximo px, turned like the preview when the customer rotated it
  function recorteJpeg(img, r, ladoMaximo, calidad) {
    if (!r.giro) return aJpeg(img, r.x, r.y, r.w, r.h, ladoMaximo, calidad);
    return new Promise(function (resolver, rechazar) {
      var escala = Math.min(1, ladoMaximo / Math.max(r.w, r.h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(r.w * escala));
      c.height = Math.max(1, Math.round(r.h * escala));
      var cx = c.getContext('2d');
      cx.fillStyle = '#FFFFFF';
      cx.fillRect(0, 0, c.width, c.height);
      dibujarGirado(cx, img, r, c.width, c.height);
      c.toBlob(
        function (blob) {
          if (blob) resolver(blob);
          else rechazar(new Error('toBlob'));
        },
        'image/jpeg',
        calidad
      );
    });
  }

  function sumaBytes(archivos) {
    return archivos.casillas.reduce(function (total, c) {
      return total + c.original.size + c.recortada.size;
    }, archivos.vista.size);
  }

  // One photo: original ≤ 4000 px + crop ≤ 3000 px. Two or more: per slot the
  // crop at ~2× the print minimum + the original reduced to ~1600 px; above
  // 12 MB the reduced originals (never the crops) are re-encoded step by step.
  async function prepararArchivos(g) {
    var n = g.ventanas.length;
    // _vista_previa from a composition of ANCHO_VISTA_PREVIA px, as before
    // (the screen size varies by device); dibujar() restores the screen size
    if (prepararComposicion(g, ANCHO_VISTA_PREVIA)) actualizarCaches(false);
    componer(g);
    // Everything is encoded in parallel (toBlob runs off the main thread);
    // each photo was already decoded once when chosen.
    var trabajos = [];
    for (var i = 0; i < n; i++) {
      var img = estado.casillas[i].foto;
      var r = recorteCasilla(i, g); // exactly as adjusted
      var p = proporcionVentana(g, i);
      var recorteMax;
      if (n === 1) {
        recorteMax = UNA_FOTO.recorte;
      } else {
        var corto = (g.pxMinimo || 750) * VARIAS_FOTOS.factorRecorte;
        recorteMax = p < 1 ? corto / p : corto * p;
      }
      trabajos.push(
        Promise.all([
          n === 1
            ? aJpeg(img, 0, 0, img.naturalWidth, img.naturalHeight, UNA_FOTO.original, UNA_FOTO.calidadOriginal)
            : aJpeg(img, 0, 0, img.naturalWidth, img.naturalHeight, VARIAS_FOTOS.original, VARIAS_FOTOS.calidadOriginal),
          recorteJpeg(img, r, recorteMax, CALIDAD_RECORTE),
          r,
          img,
          estado.casillas[i].ajuste,
        ])
      );
    }
    var resultados = await Promise.all([
      Promise.all(trabajos),
      (function () {
        var fuente = fuenteVistaPrevia(g);
        if (vistaTransparente()) return vistaPng(fuente);
        return aJpeg(fuente, 0, 0, fuente.width, fuente.height, Infinity, CALIDAD_VISTA);
      })(),
    ]);
    var archivos = {
      casillas: resultados[0].map(function (x) {
        return { original: x[0], recortada: x[1], recorte: x[2], img: x[3], ajuste: x[4] };
      }),
      vista: resultados[1],
      modo: g.modo,
      medida: estado.variante.medida,
    };

    if (n > 1 && sumaBytes(archivos) > PRESUPUESTO_BYTES) {
      for (var k = 0; k < PASOS_CALIDAD.length && sumaBytes(archivos) > PRESUPUESTO_BYTES; k++) {
        var originales = await Promise.all(
          archivos.casillas.map(function (c) {
            return aJpeg(c.img, 0, 0, c.img.naturalWidth, c.img.naturalHeight, VARIAS_FOTOS.original, PASOS_CALIDAD[k]);
          })
        );
        originales.forEach(function (o, j) {
          archivos.casillas[j].original = o;
        });
      }
    }
    archivos.total = sumaBytes(archivos);
    return archivos;
  }

  var barra = raiz.querySelector('[data-barra]');
  var botonAgregar = barra.querySelector('.personalizador-barra__boton');
  var errorBarra = barra.querySelector('[data-error-barra]');

  function mostrarErrorBarra(texto) {
    errorBarra.textContent = texto || '';
    errorBarra.hidden = !texto;
  }

  function ocupado(si) {
    botonAgregar.disabled = si;
    botonAgregar.setAttribute('aria-busy', si ? 'true' : 'false');
    var g = geometria();
    botonAgregar.textContent = si ? (varias(g) ? t.subiendoVarias : t.subiendo) : t.agregar;
  }

  function mostrarConfirmacion(si) {
    estado.confirmado = si;
    sincronizarBarra();
  }

  var consultaEscritorio = window.matchMedia('(min-width: 1024px)');

  // Bar states: normal / confirmation, or (mobile, while adjusting) the
  // adjust controls temporarily replacing price and button
  function sincronizarBarra() {
    var ajusteEnBarra = estado.ajustando && !consultaEscritorio.matches;
    barra.querySelector('[data-barra-ajuste]').hidden = !ajusteEnBarra;
    barra.querySelector('[data-barra-normal]').hidden = ajusteEnBarra || !!estado.confirmado;
    barra.querySelector('[data-barra-confirmacion]').hidden = ajusteEnBarra || !estado.confirmado;
    if (ajusteEnBarra) errorBarra.hidden = true;
  }

  async function actualizarContadorCarrito() {
    try {
      var carrito = await (await fetch(datos.rutas.carrito, { headers: { Accept: 'application/json' } })).json();
      var enlace = document.querySelector('.encabezado__carrito');
      if (!enlace) return;
      var contador = enlace.querySelector('.encabezado__contador');
      if (!contador) {
        contador = document.createElement('span');
        contador.className = 'encabezado__contador';
        contador.setAttribute('aria-hidden', 'true');
        enlace.appendChild(contador);
      }
      contador.textContent = carrito.item_count;
      var etiqueta = carrito.item_count === 1 ? t.carritoUno : t.carritoVarios.replace('__N__', carrito.item_count);
      var icono = enlace.querySelector('svg');
      if (icono) icono.setAttribute('aria-label', etiqueta);
    } catch (e) {
      // The count refreshes on the next page load anyway
    }
  }

  async function agregarAlCarrito() {
    mostrarErrorBarra('');
    var g = geometria();
    if (!g) return;
    asegurarCasillas(g);
    var vacia = estado.casillas.slice(0, g.ventanas.length).findIndex(function (c) {
      return !c.foto;
    });
    if (vacia !== -1) {
      mostrarErrorBarra(varias(g) ? plantilla(t.errorFaltanFotos, { n: vacia + 1 }) : t.errorSinFoto);
      seleccionar(vacia);
      raiz.querySelector('[data-entrada-foto]').focus();
      return;
    }
    if (g.modo === 'con_frase' && !estado.frase.trim()) {
      mostrarErrorBarra(t.errorSinFrase);
      if (entradaFrase) entradaFrase.focus();
      return;
    }
    if (estado.ajustando) salirAjuste(false);

    ocupado(true);
    var archivos;
    try {
      archivos = await prepararArchivos(g);
    } catch (e) {
      ocupado(false);
      mostrarErrorBarra(t.errorPreparar);
      return;
    }
    dibujar();
    if (archivos.total > LIMITE_BYTES) {
      ocupado(false);
      mostrarErrorBarra(t.errorPesada);
      return;
    }

    var n = archivos.casillas.length;
    var fd = new FormData();
    fd.append('id', estado.variante.id);
    fd.append('quantity', '1');
    if (g.modo === 'con_frase') {
      fd.append('properties[' + t.propFrase + ']', estado.frase.trim());
      fd.append('properties[' + t.propTipografia + ']', estado.fuente);
      fd.append('properties[' + t.propColor + ']', estado.colorNombre + ' (' + estado.color + ')');
    }
    if (estado.colorAccesorio && coloresVariante().length) {
      fd.append('properties[' + tituloColor() + ']', estado.colorAccesorio.nombre);
      fd.append('properties[_color_accesorio]', estado.colorAccesorio.hex);
    }
    fd.append('properties[_personalizador]', (datos.tipo || 'foto') + ' v1');
    fd.append('properties[_modo]', archivos.modo);
    fd.append('properties[_medida_cm]', archivos.medida || '');
    // One entry per slot; pixels of the original photo
    fd.append(
      'properties[_recorte]',
      JSON.stringify(
        archivos.casillas.map(function (c, i) {
          return {
            casilla: i + 1,
            x: Math.round(c.recorte.x),
            y: Math.round(c.recorte.y),
            ancho: Math.round(c.recorte.w),
            alto: Math.round(c.recorte.h),
            zoom: Math.round((c.ajuste ? c.ajuste.zoom : 1) * 100) / 100,
            // degrees, clockwise, around the crop's centre (x + ancho / 2, y + alto / 2)
            giro: Math.round((c.recorte.giro || 0) * 10) / 10,
            original: [c.img.naturalWidth, c.img.naturalHeight],
          };
        })
      )
    );

    try {
      for (var i = 0; i < n; i++) {
        // Single photo keeps the Phase 4 names; multi-photo numbers them per slot
        var prefijo = n === 1 ? 'properties[_foto_' : 'properties[_foto_' + (i + 1) + '_';
        var sufijo = n === 1 ? '' : '-' + (i + 1);
        await subidor.adjuntar(fd, prefijo + 'original]', archivos.casillas[i].original, 'original' + sufijo + '.jpg');
        await subidor.adjuntar(fd, prefijo + 'recortada]', archivos.casillas[i].recortada, 'recorte' + sufijo + '.jpg');
      }
      var nombreVista = archivos.vista.type === 'image/png' ? 'vista-previa.png' : 'vista-previa.jpg';
      await subidor.adjuntar(fd, 'properties[_vista_previa]', archivos.vista, nombreVista);
    } catch (e) {
      ocupado(false);
      mostrarErrorBarra(t.errorConexion);
      return;
    }

    var respuesta;
    try {
      respuesta = await fetch(datos.rutas.agregar, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    } catch (e) {
      ocupado(false);
      mostrarErrorBarra(t.errorConexion);
      return;
    }
    ocupado(false);
    if (!respuesta.ok) {
      // Never show the server's body (a 413 is an nginx HTML page)
      mostrarErrorBarra(respuesta.status === 413 ? t.errorPesada : t.errorGeneral);
      return;
    }
    // The last line added to the cart is this product's, from this page: the
    // drawer's "Crear otro" may now start over here (once)
    agregadoAqui = true;
    // The cart drawer (snippets/carrito-controlador) cancels this event and
    // opens with "Crear otro" and "Pagar"; the bar then stays normal. Without
    // the drawer, the bar shows its own confirmation.
    var agregado = new CustomEvent('carrito:agregado', { cancelable: true });
    if (document.dispatchEvent(agregado)) {
      mostrarConfirmacion(true);
      actualizarContadorCarrito();
    }
  }

  // "Crear otro": keep size, mode, font and colour; ask for new photos
  function crearOtro() {
    salirAjuste(false);
    estado.casillas.forEach(liberar);
    estado.activa = 0;
    raiz.querySelector('[data-entrada-foto]').value = '';
    estado.frase = '';
    if (entradaFrase) entradaFrase.value = '';
    actualizarContador();
    mostrarAviso('error', '');
    refrescarTodo();
    mostrarConfirmacion(false);
    mostrarListoParaOtro();
  }

  // Makes "start over" obvious: scrolls the "Elegir foto" button into view
  // (above the fixed bar on mobile), highlights it until a photo is chosen
  // (at most ~5 s) and announces it. Focus goes to the hidden file input so
  // the keyboard and screen readers land on the photo picker; its focus is
  // shown on the button.
  var temporizadorResaltado = null;
  function mostrarListoParaOtro() {
    var entradaFoto = raiz.querySelector('[data-entrada-foto]');
    var elegir = raiz.querySelector('.personalizador__elegir');
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    elegir.scrollIntoView({ block: 'end', behavior: reducido ? 'auto' : 'smooth' });
    entradaFoto.focus({ preventScroll: true });
    elegir.classList.remove('personalizador__elegir--resaltar');
    void elegir.offsetWidth; // restart the animation
    elegir.classList.add('personalizador__elegir--resaltar');
    clearTimeout(temporizadorResaltado);
    temporizadorResaltado = setTimeout(quitarResaltado, 5000);
    if (estadoAjuste) {
      estadoAjuste.textContent = '';
      setTimeout(function () {
        estadoAjuste.textContent = t.listoOtro;
      }, 100);
    }
  }

  function quitarResaltado() {
    clearTimeout(temporizadorResaltado);
    raiz.querySelector('.personalizador__elegir').classList.remove('personalizador__elegir--resaltar');
  }

  botonAgregar.addEventListener('click', agregarAlCarrito);
  barra.querySelector('.personalizador-barra__crear-otro').addEventListener('click', crearOtro);
  // "Crear otro" in the cart drawer. Start a new design right here ONLY when
  // the last line added to the cart came from this page's personalizer (same
  // product, just added), and only once per add. Otherwise the event is left
  // alone and the drawer's link goes to the Crear page, so a design the
  // customer is working on (e.g. on another product's page) is never cleared.
  // The drawer (a modal <dialog>) has just been closed in this same click;
  // closing it restores focus to the element that opened it and lifts the
  // page's scroll lock, and iOS Safari can apply that after our scroll and
  // focus, undoing them. So start over two frames later.
  var agregadoAqui = false;
  document.addEventListener('carrito:crear-otro', function (e) {
    if (!agregadoAqui) return;
    agregadoAqui = false;
    e.preventDefault();
    requestAnimationFrame(function () {
      requestAnimationFrame(crearOtro);
    });
  });

  // --- Manual adjustment of the active slot (MASTER-PLAN §6.8) ---

  var botonAjustar = raiz.querySelector('[data-ajustar]');
  var controles = raiz.querySelector('[data-controles]');
  var deslizador = raiz.querySelector('[data-zoom]');
  var estadoAjuste = raiz.querySelector('[data-estado-ajuste]');
  var instrucciones = raiz.querySelector('[data-instrucciones]');
  var cuadroPendiente = null;
  var anuncioPendiente = null;
  var anuncioInmediato = false;

  function casillaActiva() {
    return estado.casillas[estado.activa];
  }

  // Redraw at most once per frame while dragging or zooming
  function programarRedibujo() {
    if (cuadroPendiente) return;
    cuadroPendiente = requestAnimationFrame(function () {
      cuadroPendiente = null;
      actualizarCaches(true);
      dibujar();
      revisarCalidad();
      var cas = casillaActiva();
      if (deslizador && cas && cas.ajuste) deslizador.value = Math.round(cas.ajuste.zoom * 100);
      if (cas && cas.ajuste) mostrarGiroFino(cas.ajuste.fino || 0);
      if (!anuncioInmediato) programarAnuncio();
      anuncioInmediato = false;
    });
  }

  // Text description of the active slot's adjustment
  function textoAjuste() {
    var g = geometria();
    var cas = casillaActiva();
    if (!g || !cas || !cas.foto) return '';
    var img = cas.foto;
    var p = proporcionVentana(g, estado.activa);
    var auto = calcularRecorte(img.naturalWidth, img.naturalHeight, p);
    var r = recorteCasilla(estado.activa, g);
    var base = recorteBase(img.naturalWidth, img.naturalHeight, p);
    var dx = (r.x + r.w / 2 - (auto.x + auto.w / 2)) / base.w;
    var dy = (r.y + r.h / 2 - (auto.y + auto.h / 2)) / base.h;
    var direcciones = [];
    // The crop moving down means the photo moved up in the window
    if (dy > 0.03) direcciones.push(t.dirArriba);
    if (dy < -0.03) direcciones.push(t.dirAbajo);
    if (dx > 0.03) direcciones.push(t.dirIzquierda);
    if (dx < -0.03) direcciones.push(t.dirDerecha);
    var posicion = direcciones.length
      ? plantilla(t.ajusteMovida, { direccion: direcciones.join(t.dirY) })
      : t.ajusteAutomatico;
    var texto = plantilla(t.ajusteEstado, { zoom: Math.round(cas.ajuste.zoom * 100), posicion: posicion });
    var giro = Math.round(giroAjuste(cas.ajuste) * 10) / 10;
    if (giro) texto += ' ' + plantilla(t.ajusteGiro, { grados: giro });
    return varias(g) ? plantilla(t.fotoN, { n: estado.activa + 1 }) + '. ' + texto : texto;
  }

  function programarAnuncio() {
    clearTimeout(anuncioPendiente);
    anuncioPendiente = setTimeout(function () {
      estadoAjuste.textContent = textoAjuste();
    }, 400);
  }

  // Announce now (not debounced): clear first so the live region always re-reads
  function anunciarAhora() {
    anuncioInmediato = true;
    clearTimeout(anuncioPendiente);
    estadoAjuste.textContent = '';
    requestAnimationFrame(function () {
      estadoAjuste.textContent = textoAjuste();
    });
  }

  function entrarAjuste() {
    var cas = casillaActiva();
    if (!cas || !cas.foto) return;
    mostrarGaleria('diseno');
    estado.ajustando = true;
    raiz.classList.add('personalizador--ajustando');
    botonAjustar.hidden = true;
    botonAjustar.setAttribute('aria-expanded', 'true');
    controles.hidden = false;
    sincronizarBarra();
    lienzo.setAttribute('tabindex', '0');
    lienzo.setAttribute('aria-describedby', instrucciones.id);
    programarRedibujo();
    lienzo.focus({ preventScroll: true });
  }

  function salirAjuste(enfocar) {
    if (!estado.ajustando) return;
    estado.ajustando = false;
    punteros.clear();
    pellizco = null;
    raiz.classList.remove('personalizador--ajustando');
    controles.hidden = true;
    sincronizarBarra();
    botonAjustar.hidden = false;
    botonAjustar.setAttribute('aria-expanded', 'false');
    lienzo.removeAttribute('tabindex');
    lienzo.removeAttribute('aria-describedby');
    dibujar();
    if (enfocar) botonAjustar.focus();
  }

  function fijarZoom(zoom) {
    var cas = casillaActiva();
    if (!cas || !cas.ajuste) return;
    cas.ajuste.zoom = limitar(zoom, 1, ZOOM_MAXIMO);
    programarRedibujo();
  }

  // Composition pixels per CSS pixel of the visible canvas
  function escalaPantalla() {
    var ancho = lienzo.getBoundingClientRect().width;
    if (!ancho || !estado.vista) return 0;
    return lienzo.width / ancho / estado.vista.escala;
  }

  // Move the photo by a distance in CSS pixels on screen (drag direction = photo direction)
  function moverPantalla(dxCss, dyCss) {
    var g = geometria();
    var cas = casillaActiva();
    if (!g || !cas || !cas.foto) return;
    var r = recorteCasilla(estado.activa, g);
    var anchoVentana = g.ventanas[estado.activa].ancho * composicion.width; // composition px
    var escala = escalaPantalla();
    if (!escala) return;
    var fotoPorPantalla = (r.w / anchoVentana) * escala; // photo px per CSS px
    moverEnFoto(cas, dxCss * fotoPorPantalla, dyCss * fotoPorPantalla);
    programarRedibujo();
  }

  // Moves the crop centre by a screen-direction distance (photo px), turned
  // back into the photo's own axes when the photo is rotated
  function moverEnFoto(cas, dx, dy) {
    var giro = (giroAjuste(cas.ajuste) * Math.PI) / 180;
    var c = Math.cos(giro);
    var sn = Math.sin(giro);
    cas.ajuste.cx -= dx * c + dy * sn;
    cas.ajuste.cy -= -dx * sn + dy * c;
  }

  // Move by a fraction of the visible crop (keyboard)
  function moverFraccion(fx, fy) {
    var g = geometria();
    var cas = casillaActiva();
    if (!g || !cas || !cas.foto) return;
    var r = recorteCasilla(estado.activa, g);
    moverEnFoto(cas, fx * r.w, fy * r.h);
    programarRedibujo();
  }

  // Rotation: 90° steps (buttons) and a fine angle from -15° to +15° (slider)
  var deslizadorGiro = raiz.querySelector('[data-giro-fino]');
  var valorGiro = raiz.querySelector('[data-giro-valor]');

  // The fine rotation slider's value, shown next to it ("0°") and spoken
  function mostrarGiroFino(grados) {
    if (deslizadorGiro) {
      deslizadorGiro.value = grados;
      deslizadorGiro.setAttribute('aria-valuetext', plantilla(t.giroGrados, { grados: grados }));
    }
    if (valorGiro) valorGiro.textContent = grados + '°';
  }

  function girar(pasos) {
    var g = geometria();
    var cas = casillaActiva();
    if (!g || !cas || !cas.foto) return;
    recorteCasilla(estado.activa, g);
    cas.ajuste.giro90 = (((cas.ajuste.giro90 || 0) + pasos * 90) % 360 + 360) % 360;
    programarRedibujo();
    anunciarAhora();
  }

  function fijarGiroFino(grados) {
    var g = geometria();
    var cas = casillaActiva();
    if (!g || !cas || !cas.foto) return;
    recorteCasilla(estado.activa, g);
    cas.ajuste.fino = limitar(Number(grados) || 0, -GIRO_FINO_MAXIMO, GIRO_FINO_MAXIMO);
    mostrarGiroFino(cas.ajuste.fino);
    programarRedibujo();
  }

  function restablecer() {
    var cas = casillaActiva();
    if (!cas) return;
    cas.ajuste = null;
    var g = geometria();
    if (g && cas.foto) recorteCasilla(estado.activa, g); // rebuild the automatic crop (zoom 1×, no rotation) right away
    if (deslizador) deslizador.value = 100;
    mostrarGiroFino(0);
    programarRedibujo();
    anunciarAhora();
  }

  // Slot under a screen point (composition coordinates), or -1
  function casillaEnPunto(clientX, clientY) {
    var g = geometria();
    if (!g) return -1;
    if (!estado.vista) return -1;
    var rect = lienzo.getBoundingClientRect();
    var porCss = lienzo.width / rect.width;
    var vista = estado.vista;
    var x = vista.region.x + ((clientX - rect.left) * porCss - vista.ox) / vista.escala;
    var y = vista.region.y + ((clientY - rect.top) * porCss - vista.oy) / vista.escala;
    return g.ventanas.findIndex(function (v) {
      var p = rectPx(v, composicion.width, composicion.height);
      return x >= p.x && x <= p.x + p.w && y >= p.y && y <= p.y + p.h;
    });
  }

  // Pointer gestures: one finger/mouse drags, two fingers pinch to zoom
  var punteros = new Map();
  var pellizco = null;

  function distancia() {
    var p = Array.from(punteros.values());
    return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
  }

  lienzo.addEventListener('pointerdown', function (e) {
    if (!estado.ajustando) return;
    e.preventDefault();
    lienzo.setPointerCapture(e.pointerId);
    punteros.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (punteros.size === 2) pellizco = { distancia: distancia(), zoom: casillaActiva().ajuste.zoom };
  });

  lienzo.addEventListener('pointermove', function (e) {
    if (!estado.ajustando || !punteros.has(e.pointerId)) return;
    var anterior = punteros.get(e.pointerId);
    punteros.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (punteros.size === 1) {
      moverPantalla(e.clientX - anterior.x, e.clientY - anterior.y);
    } else if (punteros.size === 2 && pellizco && pellizco.distancia > 0) {
      fijarZoom((pellizco.zoom * distancia()) / pellizco.distancia);
    }
  });

  function soltar(e) {
    punteros.delete(e.pointerId);
    if (punteros.size < 2) pellizco = null;
  }
  lienzo.addEventListener('pointerup', soltar);
  lienzo.addEventListener('pointercancel', soltar);

  // Outside adjust mode, tapping a slot in a multi-slot preview selects it
  lienzo.addEventListener('click', function (e) {
    if (estado.ajustando) return;
    var g = geometria();
    if (!varias(g)) return;
    var i = casillaEnPunto(e.clientX, e.clientY);
    if (i !== -1) seleccionar(i);
  });

  // iOS Safari: keep a pinch on the preview from zooming the whole page
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (tipo) {
    lienzo.addEventListener(tipo, function (e) {
      if (estado.ajustando) e.preventDefault();
    });
  });
  lienzo.addEventListener(
    'touchmove',
    function (e) {
      if (estado.ajustando) e.preventDefault();
    },
    { passive: false }
  );

  // Keyboard alternatives
  lienzo.addEventListener('keydown', function (e) {
    if (!estado.ajustando) return;
    var paso = e.shiftKey ? 0.1 : 0.02;
    var cas = casillaActiva();
    var manejado = true;
    if (e.key === 'ArrowLeft') moverFraccion(-paso, 0);
    else if (e.key === 'ArrowRight') moverFraccion(paso, 0);
    else if (e.key === 'ArrowUp') moverFraccion(0, -paso);
    else if (e.key === 'ArrowDown') moverFraccion(0, paso);
    else if (e.key === '+' || e.key === '=') fijarZoom(cas.ajuste.zoom * 1.1);
    else if (e.key === '-' || e.key === '_') fijarZoom(cas.ajuste.zoom / 1.1);
    else if (e.key === '0') restablecer();
    else if (e.key === 'Escape') salirAjuste(true);
    else manejado = false;
    if (manejado) e.preventDefault();
  });

  // Desktop: controls under the preview. Mobile: in the bottom bar.
  function ubicarControles() {
    var destino = consultaEscritorio.matches
      ? raiz.querySelector('[data-controles-escritorio]')
      : barra.querySelector('[data-barra-ajuste]');
    if (destino && controles.parentNode !== destino) destino.appendChild(controles);
    controles.hidden = !estado.ajustando;
    sincronizarBarra();
  }
  consultaEscritorio.addEventListener('change', function () {
    ubicarControles();
    dibujar();
  });

  controles.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && estado.ajustando) {
      e.preventDefault();
      salirAjuste(true);
    }
  });

  // Redraw when the preview box changes size (rotation, keyboard, resize)
  if ('ResizeObserver' in window) {
    new ResizeObserver(function () {
      dibujar();
    }).observe(marcoLienzo);
  } else {
    window.addEventListener('resize', dibujar);
  }

  botonAjustar.addEventListener('click', entrarAjuste);
  raiz.querySelector('[data-listo]').addEventListener('click', function () {
    salirAjuste(true);
  });
  raiz.querySelector('[data-restablecer]').addEventListener('click', restablecer);
  raiz.querySelectorAll('[data-girar]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      girar(Number(boton.getAttribute('data-girar')) > 0 ? 1 : -1);
    });
  });
  if (deslizadorGiro) {
    deslizadorGiro.addEventListener('input', function () {
      fijarGiroFino(deslizadorGiro.value);
    });
  }
  deslizador.addEventListener('input', function () {
    fijarZoom(Number(deslizador.value) / 100);
  });

  // --- Wiring ---
  estado.variante = variantePorId(datos.seleccionada) || datos.variantes[0];
  if (fotosGaleria.length) mostrarGaleria(fotoPorDefecto());
  actualizarPasoColor();

  raiz.querySelectorAll('[data-variante]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (radio.checked) alCambiarVariante(radio.value);
    });
  });

  raiz.querySelector('[data-entrada-foto]').addEventListener('change', function (e) {
    alElegirFoto(e.target.files[0]);
    e.target.value = ''; // so choosing the same file again (e.g. for another slot) still fires
  });

  var bloqueFrase = raiz.querySelector('[data-bloque-frase]');
  raiz.querySelectorAll('[data-modo]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      estado.modo = radio.value;
      if (bloqueFrase) bloqueFrase.hidden = estado.modo !== 'con_frase';
      refrescarTodo();
    });
  });

  var entradaFrase = raiz.querySelector('[data-entrada-frase]');
  if (entradaFrase) {
    entradaFrase.addEventListener('input', function () {
      estado.frase = entradaFrase.value.slice(0, datos.fraseMax);
      actualizarContador();
      dibujar();
    });
    // Keyboard open: shrink the sticky preview but keep it visible
    entradaFrase.addEventListener('focus', function () {
      raiz.classList.add('personalizador--teclado');
    });
    entradaFrase.addEventListener('blur', function () {
      raiz.classList.remove('personalizador--teclado');
    });
  }

  raiz.querySelectorAll('[data-fuente]').forEach(function (radio) {
    if (radio.checked) estado.fuente = radio.value;
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      estado.fuente = radio.value;
      dibujar();
    });
  });

  raiz.querySelectorAll('[data-color]').forEach(function (radio) {
    if (radio.checked) {
      estado.color = radio.value;
      estado.colorNombre = radio.dataset.nombre;
    }
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      estado.color = radio.value;
      estado.colorNombre = radio.dataset.nombre;
      dibujar();
    });
  });

  var listo = cargarFuentes();
  if (datos.ejemplo) {
    var ej = new Image();
    ej.crossOrigin = 'anonymous';
    ej.onload = function () {
      estado.ejemplo = ej;
      refrescarTodo();
    };
    ej.src = datos.ejemplo;
  }
  listo.then(dibujar);
  ubicarControles();
  refrescarTodo();
  actualizarContador();
})();
